import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useParams, } from 'react-router-dom';
import { Modal, Button, Dropdown } from 'react-bootstrap';
//Components
import NavBar from '../Nav/NavBar';
import DeliveryProductMappingModal from './DeliveryProductMappingModal';
//External modules 
import moment from 'moment-timezone';
//img
import logo_sp from '../../../assets/img/logos/icon-black.png';
//sounds 
import newOrderSound from '../../../assets/sounds/doorbell.mp3';
//utils
import Socket from '../../utils/Socket.config';
import { RenderIf } from '../../utils/RenderIf';
import { FormatDateTime } from '../../utils/FormatDate';
//API 
import { DeliveryOrdersFetchAPI } from '../../../api/DeliveryOrders';
import { OrderNumberFetchAPI } from '../../../api/Paymentpost/OrderNumber';
import { PrinterFetchAPI } from '../../../api/Printer';
import { CategriesPosFetchAPI } from '../../../api/Paymentpost/CategoriesPos';
import { MachinesFetchAPI } from '../../../api/Machines';
import { RequestAlohaFetchAPI } from '../../../api/Paymentpost/RequestAloha';
import { PosIntegrationFetchAPI } from '../../../api/PosIntegrations';
import { TookanFetchAPI } from '../../../api/Tookan';
import { UberDirectFetchAPI } from '../../../api/UberDirect';
import { AsapFetchAPI } from '../../../api/Asap';
import { PowetranzFetchAPI } from '../../../api/Powertranz';
import { EvertechFetchAPI } from '../../../api/Evertech';
import { PaymentMethodFetchAPI } from '../../../api/Paymentpost/PaymentMethod';
import { YappyFetchAPI } from '../../../api/Paymentpost/Yappy';
import { TilopayFetchAPI } from '../../../api/Paymentpost/Tilopay';
import { ClientsFetchAPI } from '../../../api/Clients';
import { DgiFetchAPI } from '../../../api/Dgi';
import { WhatsappFetchAPI } from '../../../api/Whatsapp';
//Alerts
import SuccessAlert from '../../Alerts/SuccessAlert';
import ErrorAlert from '../../Alerts/ErrorAlert';
import LoadingAlert from '../../Alerts/LoadingAlert';
import validSession from '../../utils/validSession';
//CSS
import '../css/deliveryOrder.css'; import FullScreen from '../../FullScreen';
import HiddenImg from '../../utils/HiddenImg';

// -------------------- PICKUP APPROVAL GATE --------------------

// You can tweak this: allow approving X minutes BEFORE the pickup time
const PICKUP_APPROVE_LEAD_MINUTES = localStorage.getItem("branchoffice") != null && localStorage.getItem("branchoffice") !== undefined && localStorage.getItem("branchoffice") !== "" ? JSON.parse(localStorage.getItem('branchoffice')).approval_lead_time_minutes || 10 : 10;

// Build a moment in the order timezone (fallback to Panama)
const getOrderTz = (meta) => meta?.scheduled_timezone === "es-PA" ? "America/Panama" : meta?.scheduled_timezone || "America/Panama";

// The "unlock" moment for pickup approval
// Priority:
// 1) scheduled_window.start (if exists)
// 2) scheduled_for (if exists)
// 3) null (no gate)
const getPickupUnlockMoment = (meta) => {
    const tz = getOrderTz(meta);

    const start = meta?.scheduled_window?.start;
    const scheduledFor = meta?.scheduled_for;

    if (start) return moment.tz(start, tz).subtract(PICKUP_APPROVE_LEAD_MINUTES, "minutes");
    if (scheduledFor) return moment.tz(scheduledFor, tz).subtract(PICKUP_APPROVE_LEAD_MINUTES, "minutes");

    return null;
};

// Format seconds to a human readable string
const formatHumanTime = (totalSeconds) => {
    let secs = Math.max(0, Math.floor(Number(totalSeconds) || 0));

    const hours = Math.floor(secs / 3600);
    secs %= 3600;
    const minutes = Math.floor(secs / 60);
    const seconds = secs % 60;

    const parts = [];

    if (hours > 0) {
        parts.push(`${hours} ${hours === 1 ? "hora" : "horas"}`);
    }

    if (minutes > 0) {
        parts.push(`${minutes} ${minutes === 1 ? "minuto" : "minutos"}`);
    }

    // Always show seconds if nothing else or if there are remaining seconds
    if (seconds > 0 || parts.length === 0) {
        parts.push(`${String(seconds).padStart(2, "0")} segundos`);
    }

    return parts.join(" ");
};

// Returns { locked: boolean, secondsLeft: number, unlockAtISO: string|null }
const getScheduledGateStatus = (meta) => {
    if (!meta?.is_scheduled) return { locked: false, secondsLeft: 0, unlockAtISO: null };

    const unlockMoment = getPickupUnlockMoment(meta);
    if (!unlockMoment) return { locked: false, secondsLeft: 0, unlockAtISO: null };

    const now = moment.tz(getOrderTz(meta));
    const diffSec = Math.ceil(unlockMoment.diff(now, "seconds", true));
    const locked = diffSec > 0;

    return {
        locked,
        secondsLeft: locked ? diffSec : 0,
        unlockAtISO: unlockMoment.toISOString(),
    };
};


const paymentMethods = [{
    id: 23,
    name: "Transf./Deposito a cta. Bancaria"
}, {
    id: 14,
    name: "Evertech - Tarjeta"
}, {
    id: 6,
    name: "Yappy"
}, {
    id: 19,
    name: "Yappy"
},
{
    id: 40,
    name: "PowerTranz - Tarjeta"
},
{
    id: 10,
    name: "Credito"
},
{
    id: 37,
    name: "PedidosYa"
},
{
    id: 38,
    name: "UberEats"
}]


/********************** 🔥 PROMO HELPERS ************************/
// It converts cents to string USD
const centsToUSD = (c) => (c / 100).toFixed(2);

// It detects a smartpay key "SMARTPAY-NUMBER" and returns Number(12345) or null
const parseSmartpayId = (val) => {
    if (!val || typeof val !== 'string') return null;
    const m = val.trim().match(/^SMARTPAY\s*-\s*(\d+)$/i);
    return m ? Number(m[1]) : null;
};
// Wrappers para saber si algo ya está "mapeado directo" por SMARTPAY-<N>
const getSmartpayDirectId = (obj = {}) => {
    return (
        parseSmartpayId(obj?.external_data) ||
        parseSmartpayId(obj?.id) ||
        parseSmartpayId(obj?.remoteCode)
    );
};

const isProductMappedBySmartpay = (p, platform) => {
    if (platform === 'PEDIDOSYA') return !!parseSmartpayId(p?.remoteCode);
    // Uber: puede venir en id, o (si lo usas) en remoteCode
    return !!getSmartpayDirectId(p);
};

const isSegmentMappedBySmartpay = (seg, platform) => {
    if (platform === 'PEDIDOSYA') return !!parseSmartpayId(seg?.remoteCode);
    return !!getSmartpayDirectId(seg);
};

const isItemMappedBySmartpay = (item, platform) => {
    if (platform === 'PEDIDOSYA') return !!parseSmartpayId(item?.remoteCode);
    return !!getSmartpayDirectId(item);
};


// the discount for uber
const buildDiscountMap = (items = [], promotions = [], fallbackTotalPromo = 0) => {
    if (!promotions.length) return {};

    // 1️⃣ cuenta unidades con descuento y suma promo_discount_value
    const unitsById = {};
    let promoTotalCents = 0;

    promotions.forEach(p => {
        promoTotalCents += Math.abs(p.promo_discount_value || 0);

        p.discount_items?.forEach(({ external_id, discounted_quantity }) => {
            unitsById[external_id] =
                (unitsById[external_id] || 0) + discounted_quantity;
        });
    });

    // Si no vino promo_discount_value, usa fallback (raro, pero por si acaso)
    if (promoTotalCents === 0) promoTotalCents = fallbackTotalPromo;
    if (promoTotalCents === 0) return {};

    const totalUnits = Object.values(unitsById).reduce((a, b) => a + b, 0);
    if (!totalUnits) return {};

    const perUnit = promoTotalCents / totalUnits; // ¢ por unidad

    // 2️⃣ asigna descuento por ÍNDICE en el carrito
    const allocation = {}; // { idx: cents }
    const remaining = { ...unitsById };

    items.forEach((item, idx) => {
        const units = Math.min(remaining[item.id] || 0, item.quantity);
        if (units > 0) {
            allocation[idx] = Math.round(units * perUnit);
            remaining[item.id] -= units;
        }
    });

    return allocation;
};

// ---------- Helpers ----------
const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;


// The discount for PedidosYa (unit-based allocation, exact sum after rounding)
const buildDiscountMapFromPedidosYa = (products = [], totalPromoAmount = 0, mode = 'unit') => {

    // Parse qty and price safely
    const parseQty = (q) => {
        const n = parseInt(q ?? 0, 10);
        return Number.isFinite(n) && n > 0 ? n : 0;
    };
    const parsePrice = (p) => {
        const n = Number(p ?? 0);
        return Number.isFinite(n) && n > 0 ? n : 0;
    };

    // ---------- Guard clauses ----------
    const amount = Number(totalPromoAmount);
    if (!Array.isArray(products) || products.length === 0 || !isFinite(amount) || amount <= 0) {
        return {};
    }

    // ---------- Build line data ----------
    const lines = products.map((p, idx) => {
        const qty = parseQty(p?.quantity);
        const price = parsePrice(p?.paidPrice ?? p?.unitPrice);
        const lineTotal = round2(qty * price);         // capacity for this line
        const weight = mode === 'amount' ? lineTotal : qty; // base weight
        return {
            idx,
            qty,
            price,
            lineTotal,
            capacity: lineTotal,
            weight,
            alloc: 0,     // allocation (to be computed)
        };
    });

    // Only consider lines with positive capacity
    const eligible = lines.filter(l => l.capacity > 0);
    if (eligible.length === 0) return {};

    // If total discount > total capacity, cap at total capacity
    const totalCapacity = round2(eligible.reduce((s, l) => s + l.capacity, 0));
    const targetAmount = Math.min(amount, totalCapacity);

    // ---------- Initial allocation (proportional to weights) ----------
    let weightSum = eligible.reduce((s, l) => s + (l.weight > 0 ? l.weight : 0), 0);
    // If weights are all zero (e.g., all qty=0 but capacity>0 due to prices? Unlikely, but guard)
    if (weightSum <= 0) {
        // fallback to capacity-proportional
        weightSum = eligible.reduce((s, l) => s + l.capacity, 0);
        eligible.forEach(l => { l.weight = l.capacity; });
    }

    let allocated = 0;
    let lastIdx = -1;
    eligible.forEach((l) => {
        const rawShare = (l.weight / weightSum) * targetAmount;
        l.alloc = round2(rawShare);
        allocated = round2(allocated + l.alloc);
        lastIdx = l.idx;
    });

    // Fix rounding residual on last eligible line (no cap yet)
    let residual = round2(targetAmount - allocated);
    if (residual !== 0 && lastIdx !== -1) {
        const lastLine = lines.find(x => x.idx === lastIdx);
        lastLine.alloc = round2(lastLine.alloc + residual);
        allocated = round2(allocated + residual);
        residual = 0;
    }

    // ---------- Cap pass: ensure alloc <= capacity, collect overflow ----------
    let overflow = 0;
    eligible.forEach((l) => {
        if (l.alloc > l.capacity) {
            const over = round2(l.alloc - l.capacity);
            l.alloc = l.capacity;
            overflow = round2(overflow + over);
        }
    });

    // ---------- Redistribute overflow to lines with spare capacity ----------
    const redistribute = (res) => {
        // Loop until no residual or no spare capacity
        let loops = 0;
        while (res > 0 && loops < 10_000) {
            // Lines that can still receive more
            const receivers = eligible.filter(l => l.capacity > l.alloc + 0.000001);
            if (receivers.length === 0) break;

            // Recompute weights only among receivers (same base rule)
            let wSum = receivers.reduce((s, l) => s + (l.weight > 0 ? l.weight : 0), 0);
            if (wSum <= 0) {
                // fallback: use remaining capacity as weight
                wSum = receivers.reduce((s, l) => s + (l.capacity - l.alloc), 0);
                receivers.forEach(l => { l._tmpWeight = (l.capacity - l.alloc); });
            } else {
                receivers.forEach(l => { l._tmpWeight = l.weight; });
            }

            // Allocate this round proportionally, respecting caps
            let roundAllocated = 0;
            let lastReceiver = null;

            receivers.forEach((l) => {
                const share = (l._tmpWeight / wSum) * res;
                let add = round2(share);
                // Respect remaining capacity
                const remaining = round2(l.capacity - l.alloc);
                if (add > remaining) add = remaining;

                l.alloc = round2(l.alloc + add);
                roundAllocated = round2(roundAllocated + add);
                lastReceiver = l;
            });

            // Correct rounding residual for this round on last receiver
            let roundResidual = round2(res - roundAllocated);
            if (roundResidual !== 0 && lastReceiver) {
                const remaining = round2(lastReceiver.capacity - lastReceiver.alloc);
                const correction = Math.min(remaining, Math.abs(roundResidual));
                if (correction > 0) {
                    lastReceiver.alloc = round2(
                        lastReceiver.alloc + (roundResidual > 0 ? correction : -correction)
                    );
                    roundAllocated = round2(roundAllocated + (roundResidual > 0 ? correction : -correction));
                    roundResidual = round2(res - roundAllocated);
                }
            }

            res = roundResidual; // continue if still > 0
            loops += 1;
            // safety break on super tiny residuals
            if (Math.abs(res) < 0.005) res = 0;
        }
        return res;
    };

    if (overflow > 0) {
        overflow = round2(overflow);
        const left = redistribute(overflow);
        // If something remains (all lines capped), we just leave it (no place to put it).
        if (left > 0.009) {
            // Optional: log it
            // console.warn('Unallocatable discount residual (all lines capped):', left);
        }
    }

    // ---------- Build result map ----------
    const result = {};
    lines.forEach(l => { result[l.idx] = round2(l.alloc); });

    return result;
};

// This validates if the PedidosYa order comes with VAT info (itbms)
const hasPedidosYaVAT = (price = {}) => {
    return Number(price?.vatTotal || 0) > 0;
};

// This builds the 7% tax object for SmartPay
const buildPanamaTax = (baseAmount = 0) => {
    const taxTotal = Number(baseAmount || 0) * 0.07;
    return {
        tax_id: 1, // Use here the real ITBMS tax_id of your system
        tax: "7%",
        taxtValue: 0.07,
        dTasaITBMSValue: "07",
        percentage: "7%",
        total: taxTotal
    };
};

/***************************************************************/
const DeliveryOrders = () => {
    let { business_code, branchoffice_code } = useParams();
    let machine = localStorage.getItem('machine');
    let branchoffice = localStorage.getItem('branchoffice');
    let business = localStorage.getItem("business");
    // 🔔 Alarm audio control
    const alarmAudioRef = useRef(null);
    const [alarmActive, setAlarmActive] = useState(false);
    const [audioUnlocked, setAudioUnlocked] = useState(false);
    const [showAudioUnlock, setShowAudioUnlock] = useState(false);
    // Gate UI state
    const [pickupGate, setPickupGate] = useState({
        isPickup: false,
        isLocked: false,
        secondsLeft: 0,
        unlockAtISO: null
    });
    // Helpers for device authorization
    const isAutoAcceptEnabled = () => {
        const value = JSON.parse(localStorage.getItem('branchoffice') || '{}').ecommerce_auto_approval_orders;
        return value === 1 || value === "1" || value === true || value === "true";
    };

    const getAutoAcceptDeviceId = () =>
        JSON.parse(localStorage.getItem('branchoffice')).auto_approval_machine_code || '';

    // ⏱ deadlines for orders (timestamp in ms when auto-accepts)
    const autoAcceptDeadlinesRef = useRef(new Map()); // order_id -> deadline (ms)

    // 🔁 tick for each 1s to re-render the countdown
    const [nowTick, setNowTick] = useState(Date.now());
    useEffect(() => {
        const id = setInterval(() => setNowTick(Date.now()), 1000);
        return () => clearInterval(id);
    }, []);
    // To avoid accepting multiple times the same order
    const [processingOrders, setProcessingOrders] = useState(new Set());
    //We get the actual date 
    const minDate = moment(new Date()).tz('America/Bogota').format('YYYY-MM-DD')
    //We put the actual date in rank of all the day 
    const maxDate = minDate + 'T23:59:59.000Z';
    const token = localStorage.getItem('x-access-machine-token');
    const [checkUnlinkedProducts, setCheckUnlinkedProducts] = useState(false);
    const [deliveryOrders, setDeliveryOrders] = useState([]);
    const [sendingWhatsappManual, setSendingWhatsappManual] = useState(false);
    const [orderDetails, setOrderDetails] = useState({
        code: "",
        platform: "",
        customer: {
            name: "",
            firstName: "",
            lastName: "",
            mobilePhone: "",
            rating: ""
        },
        platformRestaurant: {
            id: ""
        },
        fulfillment_type: "delivery",
        status: "pending",
        delivery: {
            expectedDeliveryTime: "",
            riderPickupTime: null,
            address: ""
        },
        expeditionType: "delivery",
        orderDetails: [],
        price: {
            grandTotal: ""
        },
        comments: {
            customerComment: ""
        },
        scheduled_window: {
            start: "2025-12-13T09:44:00.000Z",
            end: "2025-12-13T09:44:00.000Z"
        },
        products: [],
        display_id: '',
        current_state: '',
        store: {
            id: '',
            name: '',
            external_reference_id: '',
            integrator_store_id: '',
            integrator_brand_id: '',
            merchant_store_id: ''
        },
        eater: { first_name: '', last_name: 'T.' },
        cart: { items: [], fulfillment_issues: [] },
        payment: {
            remoteCode: "",
            status: "",
            charges: { total: [], sub_total: [], total_promo_applied: { amount: 0 } }
        },
        placed_at: '',
        type: 'DELIVERY_BY_UBER',
        packaging: { disposable_items: { should_include: false } },
        eaters: [{ first_name: '', last_name: 'T.' }],
        brand: '',
        deliveries: null,
        order_manager_client_id: '',
        _id: ''

    });

    //States to manage the multiple selection to the consolidation pending orders work flow 
    const [selectedPendingInvoiceOrders, setSelectedPendingInvoiceOrders] = useState([]);
    const [isConsolidatingOrders, setIsConsolidatingOrders] = useState(false);
    // Consolidated invoice customization
    const [showConsolidatedInvoiceModal, setShowConsolidatedInvoiceModal] = useState(false);
    const [pendingConsolidatedPayload, setPendingConsolidatedPayload] = useState(null);

    // Reuse personalize invoice flow
    const [consolidatedInvoiceName, setConsolidatedInvoiceName] = useState("CONSUMIDOR FINAL");
    const [consolidatedInvoiceRuc, setConsolidatedInvoiceRuc] = useState("0");
    const [consolidatedInvoiceDv, setConsolidatedInvoiceDv] = useState("00");
    const [consolidatedDataResponse, setConsolidatedDataResponse] = useState(false);
    const [consolidatedOptionalData, setConsolidatedOptionalData] = useState(false);
    const [consolidatedClientType, setConsolidatedClientType] = useState(0);

    // Event data for consolidated invoice
    const [consolidatedEventName, setConsolidatedEventName] = useState("");
    const [consolidatedEventId, setConsolidatedEventId] = useState(null);

    // Step in the consolidation flow: 1 = select orders, 2 = confirm invoice data and create
    const [consolidatedInvoiceStep, setConsolidatedInvoiceStep] = useState(1);
    const [editableConsolidatedProducts, setEditableConsolidatedProducts] = useState([]);
    // Helper:  to normalize the ID we use for timers
    const getOrderKey = (order) => {
        if (!order) return null;
        return (
            order.order_id ||
            order.raw_payload?.id ||
            order.id ||
            order.token ||
            order.transaction_code ||
            order._id ||
            order.code ||
            null
        );
    };
    //Helper: to get the order number for display (not necessarily unique)
    const markOrderAsProcessing = (orderKey) => {
        setProcessingOrders((prev) => {
            const next = new Set(prev);
            next.add(String(orderKey));
            return next;
        });
    };
    //Helper: to unmark an order as processing (after accept/register finishes or fails)
    const unmarkOrderAsProcessing = (orderKey) => {
        setProcessingOrders((prev) => {
            const next = new Set(prev);
            next.delete(String(orderKey));
            return next;
        });
    };
    //Helper: to check if an order is being processed (to disable buttons and avoid duplicates)
    const isOrderProcessing = (orderKey) => {
        return processingOrders.has(String(orderKey));
    };
    // Helper: a stable key for the "processing" state, that doesn't change if the order is updated in the backend (e.g., with a new transaction_code after accepting)
    const getProcessingOrderKey = (order) => {
        if (!order) return null;

        return String(
            order._id ||
            order.transaction_code ||
            order.pre_order_code ||
            order.order_id ||
            order.code
        );
    };

    const getLocalStorageObject = (key) => {
        try {
            return JSON.parse(localStorage.getItem(key) || "{}");
        } catch (error) {
            return {};
        }
    };

    const hasIdempotencyValue = (value) => (
        value !== undefined && value !== null && String(value).trim() !== ""
    );

    const normalizeIdempotencyPart = (value) => String(value).trim().replace(/\s+/g, "_");

    const hashTextWithSha256 = async (value) => {
        const normalizedValue = String(value);

        if (window.crypto?.subtle && window.TextEncoder) {
            const encodedValue = new TextEncoder().encode(normalizedValue);
            const hashBuffer = await window.crypto.subtle.digest("SHA-256", encodedValue);

            return Array.from(new Uint8Array(hashBuffer))
                .map((byte) => byte.toString(16).padStart(2, "0"))
                .join("");
        }

        let hash = 0;
        for (let i = 0; i < normalizedValue.length; i++) {
            hash = ((hash << 5) - hash) + normalizedValue.charCodeAt(i);
            hash |= 0;
        }

        return `fallback-${Math.abs(hash)}`;
    };

    const getDeliveryRegisterOrderId = (order, fallbackOrderId) => (
        fallbackOrderId ||
        order?._id ||
        order?.metadata?._id ||
        order?.pre_order_id ||
        order?.metadata?.pre_order_id ||
        order?.pre_order_code ||
        order?.metadata?.pre_order_code ||
        getOrderKey(order) ||
        order?.raw_payload?.id ||
        order?.raw_payload?.shortCode ||
        order?.raw_payload?.display_id ||
        order?.metadata?.resource_id ||
        order?.metadata?.transaction_code ||
        null
    );

    const getDeliveryAcceptanceKey = (order) => {
        if (!order) return null;

        if (order.platform === "ECOMMERCE" || order.metadata?.platform === "ECOMMERCE") {
            return getDeliveryRegisterOrderId(order);
        }

        return getOrderKey(order);
    };

    const buildDeliveryRegisterIdempotencySeed = (order, fallbackOrderId) => {
        const currentBusiness = getLocalStorageObject("business");
        const currentBranch = getLocalStorageObject("branchoffice");
        const currentMachine = getLocalStorageObject("machine");
        const businessId = currentBusiness.id || currentBusiness.business_id || currentBusiness.code || business_code;
        const branchId = currentBranch.id || currentBranch.branchoffice_id || currentBranch.code || branchoffice_code;
        const machineId = currentMachine.id || currentMachine.machine_id || currentMachine.code;
        const orderId = getDeliveryRegisterOrderId(order, fallbackOrderId);
        const parts = [businessId, branchId, machineId, orderId];

        if (!parts.every(hasIdempotencyValue)) return null;

        return parts.map(normalizeIdempotencyPart).join(":");
    };

    const getDeliveryRegisterOptions = async (order, fallbackOrderId) => {
        const idempotencySeed = buildDeliveryRegisterIdempotencySeed(order, fallbackOrderId);
        const idempotencyKey = idempotencySeed ? await hashTextWithSha256(`delivery-register:${idempotencySeed}`) : null;

        return idempotencyKey ? { idempotencyKey } : undefined;
    };

    //Helper: to get the clients of the business to validate if the client of the consolidation already exists in our system, this is important because if the client already exists we can update it with the data from the DGI and use that data for future invoices, if it doesn't exist we will create it with the data from the DGI or with the manual data entered by the user
    const getClientsByBusinessForConsolidated = async () => {
        const currentBusiness = JSON.parse(localStorage.getItem('business') || "{}");
        const token = localStorage.getItem('x-access-machine-token');

        const response = await ClientsFetchAPI.getClientsByBusiness(currentBusiness.id, token);
        return response.data.data || [];
    };
    //Helper: to get the client type ID for the consolidation based on the DGI response, if the DGI response doesn't have a valid type it will return the default type ID 2 (consumidor final)
    const getClientTypeForConsolidated = async (dTipoRec) => {
        const token = localStorage.getItem('x-access-machine-token');
        try {
            const responseTypeClient = await ClientsFetchAPI.getClientType(token);
            const dataTypes = responseTypeClient.data.data || [];
            const dataNow = dataTypes.find(type => type.name.toLowerCase() === dTipoRec.toLowerCase());
            return dataNow ? dataNow.id : 2;
        } catch (err) {
            return 2;
        }
    };
    //Helper: to create a client with the data from the DGI for the consolidation, this client will be used in the invoice and in future invoices if the RUC is the same, it will only be created if the client doesn't exist, if it already exists but doesn't have the billing name and dv it will be updated with that data
    const createClientForConsolidated = async (billingName, dvValue, typeRuc, clientType) => {
        const token = localStorage.getItem('x-access-machine-token');
        const currentBusiness = JSON.parse(localStorage.getItem('business') || "{}");

        const data = {
            phone: "6000-0000",
            name: billingName,
            billing_name: billingName,
            business_code: currentBusiness.code,
            client_type_id: clientType,
            gender: "Masculino",
            client_ruc_type: typeRuc,
            ruc: consolidatedInvoiceRuc,
            dv: dvValue,
            location: "0",
            is_validated: 1,
            password: "123456789",
            passwordCheck: "123456789",
        };

        try {
            await ClientsFetchAPI.createClient(data, token);
        } catch (err) {
            console.error("Error creating consolidated client:", err);
        }
    };
    //Helper: to update the client with the data from the DGI in case it already exists but doesn't have the billing name and dv, so we can use that data for the consolidation and for future invoices
    const updateClientForConsolidated = async (billingName, dvValue, typeRuc, clientType, clientData) => {
        const token = localStorage.getItem('x-access-machine-token');
        const currentBusiness = JSON.parse(localStorage.getItem('business') || "{}");

        const data = {
            billing_name: billingName,
            dv: dvValue,
            client_type_id: clientType,
            business_code: currentBusiness.code,
            client_ruc_type: typeRuc,
        };

        try {
            await ClientsFetchAPI.updateClient(data, clientData.id, token);
        } catch (err) {
            console.error("Error updating consolidated client:", err);
        }
    };
    //Helper: to authenticate the RUC in the DGI and get the necessary data to create the client or to fill the invoice data, if the RUC is not found or there is an error it will show the manual data entry form
    const authenticationDgiForConsolidated = async (clientToUpdate) => {
        if (!consolidatedInvoiceRuc || consolidatedInvoiceRuc === "") {
            ErrorAlert("No se ha ingresado ningún RUC.", "Debes ingresar un RUC.", "warning");
            return;
        }

        LoadingAlert();

        try {
            const token = localStorage.getItem('x-access-machine-token');
            const response = await DgiFetchAPI.checkDGIContribuyent(consolidatedInvoiceRuc);
            const dataDgi = response.data;

            const dTipoRec = dataDgi?.dgi_response?.dTipoRec || "Consumidor final";
            const clientType = await getClientTypeForConsolidated(dTipoRec);
            setConsolidatedClientType(clientType);

            if (dataDgi?.dgi_response?.gResProc?.dCodRes === "0680") {
                let dvDgi = dataDgi.dgi_response.dDV;
                if (dvDgi.length < 2) dvDgi = "0" + dvDgi;

                setConsolidatedInvoiceName(dataDgi.dgi_response.dNomb);
                setConsolidatedInvoiceDv(dvDgi);
                setConsolidatedDataResponse(true);

                SuccessAlert("Datos obtenidos", "Datos del cliente obtenidos por la DGI", "success");

                if (clientToUpdate) {
                    await updateClientForConsolidated(
                        dataDgi.dgi_response.dNomb,
                        dvDgi,
                        dataDgi.dgi_response.dTipoRuc,
                        clientType,
                        clientToUpdate
                    );
                } else {
                    await createClientForConsolidated(
                        dataDgi.dgi_response.dNomb,
                        dvDgi,
                        dataDgi.dgi_response.dTipoRuc,
                        clientType
                    );
                }
            } else {
                setConsolidatedOptionalData(true);
                ErrorAlert("Ingrese los datos manualmente.", "Datos no encontrados", "warning");
            }
        } catch (err) {
            setConsolidatedOptionalData(true);
            ErrorAlert("Ingrese los datos manualmente.", "Datos no encontrados", "warning");
        }
    };
    //Helper to validate if the client exists in our system and has the necessary data to consolidate, if not it will try to get the data from the DGI, if the client doesn't exist it will create it with the data from the DGI or with the manual data entered by the user
    const validDataClientForConsolidated = async () => {
        try {
            const clients = await getClientsByBusinessForConsolidated();
            const result = clients.find(({ ruc }) => ruc === consolidatedInvoiceRuc);

            if (!result) {
                await authenticationDgiForConsolidated();
                return;
            }

            if (result.billing_name) {
                setConsolidatedInvoiceName(result.billing_name);
                setConsolidatedInvoiceDv(result.dv);
                setConsolidatedDataResponse(true);
            } else {
                await authenticationDgiForConsolidated(result);
            }
        } catch (err) {
            await authenticationDgiForConsolidated();
        }
    };


    // Ref to always have the latest deliveryOrders in async callbacks
    const deliveryOrdersRef = useRef(deliveryOrders);

    const [showRejectModal, setShowRejectModal] = useState(false);
    const [rejectPlatform, setRejectPlatform] = useState(null);
    const [selectedReason, setSelectedReason] = useState(null);
    const [orderToReject, setOrderToReject] = useState(null);
    const [unlinkedProducts, setUnlinkedProducts] = useState([]);
    const [unlinkedSegments, setUnlinkedSegments] = useState([]);
    const [unlinkedItems, setUnlinkedItems] = useState([]);
    const [showMappingModal, setShowMappingModal] = useState(false);
    const [mappingPlatform, setMappingPlatform] = useState("");
    const [discountAllocation, setDiscountAllocation] = useState({}); // {idx: cents}
    const [eventHandler, setEventHandler] = useState(0);
    const [infoPrinter, setInfoPrinter] = useState({ printer_comanda: "", printer_ticket: "", printer_ip: "" })
    const [printers, setPrinters] = useState([]);
    const printersRef = useRef(printers); //Ref to get the actual value of printers
    const [activeTab, setActiveTab] = useState('ALL'); // ALL | PEDIDOSYA | UBER_EATS

    //SOCKET FLAG TO AVOID MULTIPLE HANDLERS
    const socketRef = useRef(null);

    const preOrderInvoice = false;
    const dataPreOrder = {
        pre_Order: false
    }
    // Timers for each order to cancel if there are manual updates or socket updates
    const autoAcceptTimersRef = useRef(new Map()); // order_id -> timeoutId
    const pendingAcceptRef = useRef(new Set());    // order_id in progress to accept
    const deliveryRegisterInFlightRef = useRef(new Map());
    const deliveryRegisterCompletedRef = useRef(new Map());

    const withDeliveryRegisterReuseFlag = (response, reused) => (
        response && typeof response === "object"
            ? { ...response, __deliveryRegisterReused: reused }
            : response
    );

    const registerDeliveryOrderOnce = async (payload, order, fallbackOrderId) => {
        const options = await getDeliveryRegisterOptions(order, fallbackOrderId);
        const idempotencyKey = options?.idempotencyKey;

        if (!idempotencyKey) {
            return OrderNumberFetchAPI.registerOrder(payload, token, options);
        }

        if (deliveryRegisterCompletedRef.current.has(idempotencyKey)) {
            return withDeliveryRegisterReuseFlag(
                deliveryRegisterCompletedRef.current.get(idempotencyKey),
                true
            );
        }

        if (deliveryRegisterInFlightRef.current.has(idempotencyKey)) {
            const response = await deliveryRegisterInFlightRef.current.get(idempotencyKey);
            return withDeliveryRegisterReuseFlag(response, true);
        }

        const registerPromise = OrderNumberFetchAPI.registerOrder(payload, token, options)
            .then((response) => {
                deliveryRegisterCompletedRef.current.set(idempotencyKey, response);
                return response;
            })
            .finally(() => {
                deliveryRegisterInFlightRef.current.delete(idempotencyKey);
            });

        deliveryRegisterInFlightRef.current.set(idempotencyKey, registerPromise);

        const response = await registerPromise;
        return withDeliveryRegisterReuseFlag(response, false);
    };

    const allOrders = deliveryOrders;
    const pyOrders = useMemo(() => deliveryOrders.filter(o => o.platform === 'PEDIDOSYA'), [deliveryOrders]);
    const uberOrders = useMemo(() => deliveryOrders.filter(o => o.platform === 'UBER_EATS'), [deliveryOrders]);
    const ecommerceDeliveryOrders = useMemo(() => deliveryOrders.filter(o => o.platform === "ECOMMERCE" && o.fulfillment_type === "delivery"), [deliveryOrders]);
    const pickupEcommerceOrders = useMemo(() => deliveryOrders.filter(o => o.platform === "ECOMMERCE" && o.fulfillment_type === "pickup"), [deliveryOrders]);
    const ecommercePendingInvoiceOrders = useMemo(() => deliveryOrders.filter(o => o.platform === "ECOMMERCE" && o.status === "order_accepted_pending_invoice"), [deliveryOrders]);
    const counts = useMemo(() => ({
        ALL: allOrders.length,
        PEDIDOSYA: pyOrders.length,
        UBER_EATS: uberOrders.length,
        ECOMMERCE_DELIVERY: ecommerceDeliveryOrders.length,
        ECOMMERCE_PICKUP: pickupEcommerceOrders.length,
        ECOMMERCE_PENDING_INVOICE: ecommercePendingInvoiceOrders.length
    }), [allOrders, pyOrders, uberOrders, ecommerceDeliveryOrders, pickupEcommerceOrders, ecommercePendingInvoiceOrders]);

    // Helper to get orders for the active tab
    const ordersForActiveTab = useMemo(() => {
        if (activeTab === 'PEDIDOSYA') return pyOrders;
        if (activeTab === 'UBER_EATS') return uberOrders;
        if (activeTab === 'ECOMMERCE_DELIVERY') return ecommerceDeliveryOrders;
        if (activeTab === 'ECOMMERCE_PICKUP') return pickupEcommerceOrders;
        if (activeTab === 'ECOMMERCE_PENDING_INVOICE') return ecommercePendingInvoiceOrders;
        return allOrders;
    }, [activeTab, allOrders, pyOrders, uberOrders, ecommerceDeliveryOrders, pickupEcommerceOrders, ecommercePendingInvoiceOrders]);

    // Stats for header cards (money + count) based on active tab
    const statsForActiveTab = useMemo(() => {
        let totalMoney = 0;

        ordersForActiveTab.forEach(order => {
            if (order.platform === 'PEDIDOSYA') {
                // PedidosYa nos manda montos ya en dólares
                const valPY =
                    parseFloat(order?.raw_payload?.price?.grandTotal) ||
                    parseFloat(order?.raw_payload?.price?.total) ||
                    0;
                if (Number.isFinite(valPY)) {
                    totalMoney += valPY;
                }
            } else if (order.platform === 'UBER_EATS') {
                // Uber Eats maneja centavos
                const centsUE =
                    order?.raw_payload?.payment?.charges?.total?.amount ??
                    0;
                if (Number.isFinite(centsUE)) {
                    totalMoney += (centsUE / 100);
                }
            } else {
                // fallback por si en el futuro hay otra plataforma
                const fallback =
                    parseFloat(order?.raw_payload?.price?.grandTotal) ||
                    0;
                if (Number.isFinite(fallback)) {
                    totalMoney += fallback;
                }
            }
        });

        return {
            money: totalMoney,
            count: ordersForActiveTab.length
        };
    }, [ordersForActiveTab]);



    //Helper: to check if the active tab is the "Pending Invoice" one, to show the checkboxes and enable the bulk actions
    const isPendingInvoiceTab = activeTab === "ECOMMERCE_PENDING_INVOICE";

    const isOrderSelectedForInvoice = (orderId) => {
        return selectedPendingInvoiceOrders.includes(String(orderId));
    };

    const togglePendingInvoiceSelection = (orderId) => {
        const normalizedId = String(orderId);

        setSelectedPendingInvoiceOrders((prev) => {
            if (prev.includes(normalizedId)) {
                return prev.filter((id) => id !== normalizedId);
            }
            return [...prev, normalizedId];
        });
    };

    const selectAllPendingInvoiceOrders = () => {
        const ids = ecommercePendingInvoiceOrders.map((order) => String(order._id));
        setSelectedPendingInvoiceOrders(ids);
    };

    const clearPendingInvoiceSelection = () => {
        setSelectedPendingInvoiceOrders([]);
    };

    // Whenever we switch away from the "Pending Invoice" tab, we clear the selection (since it only makes sense in that context)
    useEffect(() => {
        if (activeTab !== "ECOMMERCE_PENDING_INVOICE") {
            setSelectedPendingInvoiceOrders([]);
        }
    }, [activeTab]);

    //function action print order
    let arrayPrintersTemp = []
    const rejectionReasons = {
        UBER_EATS: [
            { code: "ITEM_AVAILABILITY", label: "Producto no disponible" },
            { code: "STORE_CLOSED", label: "Tienda cerrada" },
            { code: "CAPACITY", label: "Demasiadas órdenes" },
            { code: "POS_OFFLINE", label: "Problema técnico en la tienda" },
            { code: "MISSING_ITEM", label: "Al pedido le falta una selección de menú requerida" },
            { code: "PRICING", label: "Desajuste en el precio de los artículos" },
            { code: "OTHER", label: "Otro" },
        ],
        PEDIDOSYA: [
            { code: "MENU_ACCOUNT_SETTINGS", label: "Desajuste en el precio de los artículos del menu" },
            { code: "NO_RESPONSE", label: "Servidor no disponible" },
            { code: "TOO_BUSY", label: "Demasiadas órdenes" },
            { code: "CLOSED", label: "Tienda cerrada" }
        ],
        ECOMMERCE: [
            { code: "OUT_OF_SERVICE_AREA", label: "Fuera del área de servicio" },
            { code: "STORE_CLOSED", label: "Tienda cerrada" },
            { code: "ITEM_UNAVAILABLE", label: "Artículo no disponible" },
            { code: "OUT_OF_STOCK", label: "Producto agotado" },
            { code: "CANCELLED_BY_USER", label: "Cancelado por el usuario" },
            { code: "OTHER", label: "Otro" },
        ]
    };


    //--------------------- Filter Helpers ---------------------//
    // Time filter: TODAY | 7D | 1M | 3M | 1Y | ALL
    const [timeRange, setTimeRange] = useState("TODAY");

    // Always use Panama timezone for date ranges
    const TZ = "America/Panama";

    const buildRange = (rangeKey) => {
        const now = moment.tz(TZ);

        if (rangeKey === "ALL") {
            return { minISO: "", maxISO: "" };
        }

        let startDay;
        let endDay = now.clone(); // hoy en Panamá

        switch (rangeKey) {
            case "TODAY":
                startDay = now.clone();
                break;

            case "7D":
                startDay = now.clone().subtract(7, "days");
                break;

            case "1M":
                startDay = now.clone().subtract(1, "month");
                break;

            case "3M":
                startDay = now.clone().subtract(3, "months");
                break;

            case "1Y":
                startDay = now.clone().subtract(1, "year");
                break;

            default:
                startDay = now.clone();
        }

        // 🔒 format by day
        const startUTC = moment.utc({
            year: startDay.year(),
            month: startDay.month(),
            day: startDay.date(),
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0
        });

        const endUTC = moment.utc({
            year: endDay.year(),
            month: endDay.month(),
            day: endDay.date(),
            hour: 23,
            minute: 59,
            second: 59,
            millisecond: 999
        });

        return {
            minISO: startUTC.toISOString(), // 🔥 00:00:00.000Z
            maxISO: endUTC.toISOString()    // 🔥  23:59:59.999Z
        };
    };



    //Handler to get the configuration params of the selected integration
    const getConfigParams = async () => {
        try {
            let branch = JSON.parse(localStorage.getItem('branchoffice'));
            //We get the configuration params for the selected integration
            const configParams = await PosIntegrationFetchAPI.getPosIntegrationParamsByBranch(5, branch.id, token);
            //We search on the config params the data relevant to use on the localstorage 
            configParams.data.params_values.forEach(param => {
                if (param.param_name === "auto_accept_order") {
                    localStorage.setItem('auto_accept_enabled', param.value || '');
                }
                if (param.param_name === "smartpay_pedidosya_default_machine_code") {
                    localStorage.setItem('auto_accept_device_id', param.value || '');
                }
            })
        } catch (err) {
            console.error("Error fetching configuration params:", err);
        }
    };

    const canAutoAcceptAndRegister = (order) => {
        const platform = order.platform;
        // ✅ ECOMMERCE: allow if not scheduled, or scheduled but already unlocked
        if (platform === "ECOMMERCE" && (order.fulfillment_type === "delivery" || order.fulfillment_type === "pickup")) {
            const meta = order.metadata || order.raw_payload || order; // safety

            if (meta?.is_scheduled) {
                const gate = getScheduledGateStatus(meta);
                //if (gate.locked) return false; // 🔒 still locked => no auto accept/register
            }

            return true;
        }
        // ✅ PEDIDOSYA: always allow auto-accept/register
        if (platform !== "PEDIDOSYA" && platform !== "UBER_EATS") return false;

        const generalData = JSON.parse(localStorage.getItem("generalData") || "[]");
        const smartpayGroups = generalData?.[0]?.data?.groups || [];
        const externalSegments = generalData?.[0]?.data?.externalDeliverySegments || [];
        const externalItems = generalData?.[0]?.data?.externalDeliveryItems || [];

        const mappedExternalIds = new Set(
            smartpayGroups.flatMap(g => g.externalIntegrationIds?.map(e => e.external_id) || [])
        );
        const mappedSegmentIds = new Set(externalSegments.map(s => s.external_id));
        const mappedItemIds = new Set(externalItems.map(i => i.external_id));

        const raw = order?.raw_payload || order || {};
        const products = platform === "UBER_EATS"
            ? raw?.cart?.items || []
            : raw?.products || [];
        // No mapeados (producto)
        const unlinkedProductsLocal = products.filter(p => {
            const pid = p.external_data || p.id || p.external_id || p.externalId || p.remoteCode;
            const direct = isProductMappedBySmartpay(p, platform);
            if (direct) return false; // directo => no falta mapeo
            return !mappedExternalIds.has(pid);
        });

        const modifiers = platform === "UBER_EATS"
            ? products.flatMap(p => p.selected_modifier_groups || [])
            : [
                ...products.flatMap(p => p.selectedToppings || []),
                ...products.flatMap(p => p.selectedChoices || [])
            ];

        const unlinkedSegmentsLocal = modifiers.filter(m => {
            const directSeg = isSegmentMappedBySmartpay(m, platform);
            if (directSeg) return false;
            const mid = m.external_data || m.id || m.external_id || m.externalId || m.remoteCode;
            return !mappedSegmentIds.has(mid);
        });

        const unlinkedItemsLocal = modifiers.flatMap(m => {
            const items = platform === "UBER_EATS" ? m.selected_items || [] : m.children || [];
            return items.filter(i => {
                const directItem = isItemMappedBySmartpay(i, platform);
                if (directItem) return false;
                const iid = i.external_data || i.id || i.external_id || i.remoteCode;
                return !mappedItemIds.has(iid);
            });
        });

        const needsMapping = unlinkedProductsLocal.length > 0 || unlinkedSegmentsLocal.length > 0 || unlinkedItemsLocal.length > 0;

        // si falta mapeo, no hacemos nada 
        if (needsMapping) {
            setUnlinkedProducts(unlinkedProductsLocal);
            setUnlinkedSegments(unlinkedSegmentsLocal);
            setUnlinkedItems(unlinkedItemsLocal);
            setMappingPlatform(platform);
            setCheckUnlinkedProducts(true);
            if (platform === "UBER_EATS") {
                setShowMappingModal(true);
            }
            return false;
        }
        return true;
    };


    const getCategoriesByprinter = async (printer) => {

        try {
            const response = await CategriesPosFetchAPI.getCategoriesByPrinters(printer.printer_id, localStorage.getItem('x-access-machine-token'))
            printer.categories = response.data.categories

        } catch (err) {
            printer.categories = []
            console.log(err);
        }
        arrayPrintersTemp.push(printer)

    }
    const getPrinter = async () => {
        try {
            const response = await PrinterFetchAPI.getPrinter(localStorage.getItem('x-access-machine-token'), machine.id);

            let arrayPrinters = response.data.printers;
            let printer_Comanda = "";
            let printer_ticket = "";
            let printer_zebra = "";
            let printer_ip = "";
            for (let i = 0; i < arrayPrinters.length; i++) {
                getCategoriesByprinter(arrayPrinters[i])
                if (arrayPrinters[i].printer_type == 'Tickets') {
                    printer_ticket = arrayPrinters[i].printer_name
                    printer_ip = arrayPrinters[i].ip || ""
                } else if (arrayPrinters[i].printer_type == 'Comanda') {
                    printer_Comanda = arrayPrinters[i].printer_name
                } else if (arrayPrinters[i].printer_type == 'Zebra') {
                    printer_zebra = arrayPrinters[i].printer_name;
                }
            }

            setPrinters(arrayPrintersTemp)
            setInfoPrinter({ printer_comanda: printer_Comanda, printer_ticket: printer_ticket, printer_zebra: printer_zebra, printer_ip: printer_ip });

        } catch (err) {
            console.log(err);
        }
    }


    //We validate if the branch
    if (machine !== null && machine !== undefined && machine !== '') {
        machine = JSON.parse(localStorage.getItem('machine'))
    }

    if (branchoffice !== null && branchoffice !== undefined && branchoffice !== '') {
        branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
    }

    const CardInfo = (props) => {
        return <>
            <div class="col-12 my-2">
                <span >
                    <div class="stat-icon"></div>
                    <small class="stat-title d-block">{props.title}</small>
                    <strong class="stat-value">{props.data}</strong>
                </span>
            </div>
        </>;
    };

    //Function to populate the transaction list 
    const transactionList = (orders) => {
        let list = <></>;
        //We check if the delivery orders are empty
        if (orders.length > 0) {
            list = orders.map((order) => (
                <React.Fragment key={getDeliveryAcceptanceKey(order) || getOrderKey(order)}>
                    {/* ⏱ Contador visible si hay deadline para esta orden */}
                    {(() => {
                        const deadline = autoAcceptDeadlinesRef.current.get(getDeliveryAcceptanceKey(order));
                        if (!deadline) return null; // no programada en este dispositivo

                        let secs = Math.ceil((deadline - nowTick) / 1000);
                        if (secs <= 0) {
                            return <span className="badge bg-secondary ms-2">auto-aceptando…</span>;
                        }

                        const badgeClass =
                            secs <= 3 ? 'bg-danger' :
                                secs <= 7 ? 'bg-warning text-dark' : 'bg-primary';

                        return (
                            <span className={`badge ${badgeClass} ms-2`}>
                                auto-acepta en {secs}s
                            </span>
                        );
                    })()}


                    <div className='btn-group m-1'>
                        {isPendingInvoiceTab && order.platform === "ECOMMERCE" && order.status === "order_accepted_pending_invoice" && (
                            <div className="d-flex justify-content-end mb-1">
                                <div
                                    className="form-check"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={isOrderSelectedForInvoice(order._id)}
                                        onChange={() => togglePendingInvoiceSelection(order._id)}
                                        onClick={(e) => e.stopPropagation()}
                                    />
                                    <label className="form-check-label small fw-semibold">
                                        Seleccionar
                                    </label>
                                </div>
                            </div>
                        )}
                        <input
                            className="btn-check-sp input-visually-hidden"
                            type="radio" name="listGroupCheckableRadios"
                            id={"listGroupCheckableRadios" + order.order_id} value=""
                            // Controlled so a programmatic orderDetails change (auto-approval) also
                            // clears the PREVIOUS radio's native :checked state - left uncontrolled,
                            // the CSS ":checked" highlight only follows an actual click and can stay
                            // stuck on a stale, no-longer-selected order.
                            checked={getOrderKey(order) === getOrderKey(orderDetails)}
                            onChange={() => { }} />



                        <label className={`btn btn-choice p-lg-2 p-1 border ${isPendingInvoiceTab && isOrderSelectedForInvoice(order._id)
                            ? "border-primary border-3 bg-primary-subtle"
                            // The radio's native :checked highlight only updates on an actual click,
                            // so it goes stale when orderDetails changes programmatically (e.g. an
                            // auto-approval). Driving the highlight off getOrderKey instead keeps it
                            // in sync with whatever orderDetails currently shows.
                            : (getOrderKey(order) === getOrderKey(orderDetails) ? "active" : "")
                            }`} onClick={() => {
                                stopAlarm()//We stop the alarm
                                // 👇 si es ECOMMERCE no hacemos ningún mapeo
                                if (order.platform === "ECOMMERCE") {
                                    // el payload real viene en order.metadata
                                    setOrderDetails({
                                        ...order.metadata,
                                        platform: order.platform,
                                        status: order.status,
                                        fulfillment_type: order.fulfillment_type,
                                        store_name: order.store_name,
                                        customer_name: order.customer_name,
                                        customer_phone: order.customer_phone,
                                        created_time: order.created_time || order.createdAt,
                                        //pre_order_code: order.metadata?.pre_order_code || order.order_id,
                                        // getOrderKey checks order_id before _id/transaction_code - without
                                        // it here, this never matches the list item's key and the highlight
                                        // can't track the selected order.
                                        order_id: order.order_id,
                                        _id: order._id,
                                        registered_transaction_code: order.registered_transaction_code,
                                        registered_order_id: order.registered_order_id,
                                        consolidation_group_id: order.consolidation_group_id,
                                        invoice_pending: order.invoice_pending,
                                        approved_without_register: order.approved_without_register,
                                    });
                                    setShowMappingModal(false);
                                    setUnlinkedProducts([]);
                                    setUnlinkedSegments([]);
                                    setUnlinkedItems([]);
                                    return;
                                }

                                //If not we continue the workflow with pedidosya and uber
                                setOrderDetails({ ...order.raw_payload, platform: order.platform, status: order.status });
                                // Construir mapa de descuentos y guardarlo
                                if (order.platform === 'UBER_EATS') {
                                    /*   const promos = order.raw_payload?.payment?.promotions?.promotions || [];
                                      setDiscountMap(buildDiscountMap(promos)); */
                                    const items = order.raw_payload.cart?.items || [];
                                    const promos = order.raw_payload.payment?.promotions?.promotions || [];
                                    const totalPromo = order.raw_payload.payment?.charges?.total_promo_applied?.amount || 0;
                                    setDiscountAllocation(buildDiscountMap(items, promos, totalPromo));
                                } else {
                                    const items = order.raw_payload?.products || []
                                    const totalDescuento = parseFloat(order.raw_payload?.price?.discountAmountTotal || 0);
                                    setDiscountAllocation(buildDiscountMapFromPedidosYa(items, totalDescuento, "unit"));
                                }

                                // Verifica si hay productos no enlazados
                                const platform = order.platform;
                                // Obtener los productos externos desde la orden
                                const products = platform === "UBER_EATS"
                                    ? order.raw_payload?.cart?.items
                                    : order.raw_payload?.products || [];

                                // Obtener los grupos de productos SmartPay con externalIntegrationIds
                                const generalData = JSON.parse(localStorage.getItem("generalData"));
                                const smartpayGroups = generalData?.[0]?.data?.groups || [];
                                const externalSegments = generalData?.[0]?.data?.externalDeliverySegments || [];
                                const externalItems = generalData?.[0]?.data?.externalDeliveryItems || [];

                                // Obtener todos los external_id mapeados en un Set
                                const mappedExternalIds = new Set(
                                    smartpayGroups.flatMap(group =>
                                        group.externalIntegrationIds?.map(e => e.external_id) || []
                                    )
                                );
                                //We get the mapped segment IDs
                                const mappedSegmentIds = new Set(
                                    externalSegments.map(s => s.external_id)
                                );

                                const mappedItemIds = new Set(
                                    externalItems.map(i => i.external_id)
                                );
                                console.log("Mapped External IDs:", mappedExternalIds);
                                console.log("Products:", products);
                                // Filtrar productos no mapeados
                                const unlinkedProducts = products.filter(p => {
                                    if (isProductMappedBySmartpay(p, platform)) return false;
                                    const pid = p.id || p.external_id || p.externalId || p.remoteCode || p.title;
                                    return !mappedExternalIds.has(pid);
                                });
                                console.log("Unlinked Products:", unlinkedProducts);
                                // ️🔥 Aquí obtenemos modificadores por plataforma
                                const modifiers = platform === "UBER_EATS"
                                    ? products.flatMap(p => p.selected_modifier_groups || [])
                                    : products.flatMap(p => [...(p.selectedToppings || []), ...(p.selectedChoices || [])]);


                                // Segmentos no mapeados
                                const unlinkedSegments = modifiers.filter(m => {
                                    if (isSegmentMappedBySmartpay(m, platform)) return false;
                                    const mid = m.id || m.external_id || m.externalId;
                                    return !mappedSegmentIds.has(mid);
                                });

                                // Ítems no mapeados
                                const unlinkedItems = modifiers.flatMap(m => {
                                    const items = m.selected_items || m.children || [];
                                    return items.filter(i => {
                                        if (isItemMappedBySmartpay(i, platform)) return false;
                                        const iid = i.id || i.external_id || i.remoteCode || i.title;
                                        return !mappedItemIds.has(iid);
                                    });
                                });

                                const needsMapping = unlinkedProducts.length > 0 || unlinkedSegments.length > 0 || unlinkedItems.length > 0;

                                //Filtrar segmentos no mapeados 
                                // Si hay productos no enlazados, mostrar el modal
                                if (needsMapping) {
                                    setUnlinkedProducts(unlinkedProducts);
                                    setUnlinkedSegments(unlinkedSegments);
                                    setUnlinkedItems(unlinkedItems);
                                    setMappingPlatform(platform);
                                    setCheckUnlinkedProducts(true);
                                    setShowMappingModal(true);
                                } else {
                                    // 🔧 Importante: limpiar restos previos y NO abrir modal
                                    setUnlinkedProducts([]);
                                    setUnlinkedSegments([]);
                                    setUnlinkedItems([]);
                                    setShowMappingModal(false);
                                }

                            }

                            } for={"listGroupCheckableRadios" + order.order_id}>
                            <RenderIf isTrue={order.platform === "PEDIDOSYA"}>
                                <div className='d-flex justify-content-between align-items-center '>
                                    <span className='fw-bold'><i class="fa-solid fa-receipt"></i> Order ID :{order?.raw_payload?.shortCode || "No registrado"} </span>
                                    <span className="d-block small 0 text-danger px-1 rounded-4">
                                        <span><i class="fa-solid fa-person-biking"></i> Plataforma: Pedidos Ya</span>
                                    </span>
                                </div>

                            </RenderIf>
                            <RenderIf isTrue={order.platform === "UBER_EATS"}>
                                <span className='fw-bold'>Order de :{order?.raw_payload?.eater?.first_name || "No registrado"} </span>
                                <span className="d-block small  text-success px-1 rounded-4">
                                    <span><i class="uil uil-truck"></i> Plataforma:Uber Eats </span>
                                </span>
                            </RenderIf>
                            <RenderIf isTrue={order.platform === "ECOMMERCE"}>
                                <span className='fw-bold'><i class="fa-solid fa-receipt"></i> Order ID :{order?.metadata?.transaction_code || "No registrado"} </span>
                                <span className="d-block small  text-success px-1 rounded-4">
                                    <span><i class="uil uil-truck"></i> Plataforma: Smartpay </span>
                                </span>
                            </RenderIf>

                            <RenderIf isTrue={order.status === "pending"}>
                                <div class="status-item status-warning">
                                    <span class="timeline-dot bg-warning"></span>
                                    <span class="text-warning fw-bold">Pendiente de revisar</span>
                                    <small class="text-muted d-block mt-1 ms-3">Esperando confirmación</small>
                                </div>

                            </RenderIf>

                            <RenderIf isTrue={order.status === "rejected"}>
                                <div class="status-item status-danger">
                                    <span class="timeline-dot bg-danger"></span>
                                    <span class="text-danger fw-bold">Rechazada</span>
                                    <small class="text-muted d-block mt-1 ms-3">Pedido rechazado por el establecimiento</small>
                                </div>
                            </RenderIf>

                            <RenderIf isTrue={order.status === "order_canceled"}>

                                <div class="status-item status-danger">
                                    <span class="timeline-dot bg-danger"></span>
                                    <span class="text-danger fw-bold">Cancelada</span>
                                </div>
                            </RenderIf>

                            <RenderIf isTrue={order.status === "ORDER_CANCELLED"}>

                                <div class="status-item status-danger">
                                    <span class="timeline-dot bg-danger"></span>
                                    <span class="text-danger fw-bold">Cancelada</span>
                                </div>
                            </RenderIf>

                            <RenderIf isTrue={order.status === "order_rejected"}>
                                <div class="status-item status-danger">
                                    <span class="timeline-dot bg-danger"></span>
                                    <span class="text-danger fw-bold">Rechazada</span>
                                </div>
                            </RenderIf>

                            <RenderIf isTrue={order.status === "order_accepted"}>
                                <div class="status-item status-success">
                                    <span class={`timeline-dot ${order.consolidation_group_id ? "bg-primary" : "bg-success"}`}></span>
                                    <span class={`${order.consolidation_group_id ? "text-primary" : "text-success"} fw-bold`}>
                                        {order.consolidation_group_id ? "Consolidada" : "Aceptada"}
                                    </span>
                                    <small class="text-muted d-block mt-1 ms-3">
                                        {order.consolidation_group_id
                                            ? `Facturada en transacción ${order.registered_transaction_code || "No registrada"}`
                                            : "Pedido confirmado y procesado"}
                                    </small>
                                </div>
                            </RenderIf>
                            <RenderIf isTrue={order.status === "order_accepted_pending_invoice"}>
                                <div class="status-item status-info">
                                    <span class="timeline-dot bg-info"></span>
                                    <span class="text-info fw-bold">Aprobada sin registrar</span>
                                    <small class="text-muted d-block mt-1 ms-3">Pendiente de facturación</small>
                                </div>
                            </RenderIf>

                            {isPendingInvoiceTab && isOrderSelectedForInvoice(order._id) && (
                                <div className="mb-1">
                                    <span className="badge bg-primary">Seleccionada para consolidación</span>
                                </div>
                            )}
                            <RenderIf isTrue={order.status === "order_prepared"}>
                                <div class="status-item status-success">
                                    <span class="timeline-dot bg-success"></span>
                                    <span class="text-success fw-bold">Preparada</span>
                                    <small class="text-muted d-block mt-1 ms-3">Tu pedido está listo</small>
                                </div>
                            </RenderIf>
                            <RenderIf isTrue={order.status === "order_picked_up"}>
                                <div class="status-item status-success">
                                    <span class="timeline-dot bg-success"></span>
                                    <span class="text-success fw-bold">Entregada</span>
                                    <small class="text-muted d-block mt-1 ms-3">Pedido confirmado y procesado</small>
                                </div>
                            </RenderIf>
                            <RenderIf isTrue={order.status === "COURIER_ARRIVED_AT_VENDOR"}>
                                <div class="status-item status-success">
                                    <span class="timeline-dot bg-success"></span>
                                    <span class="text-success fw-bold">Repartidor en tienda</span>
                                    <small class="text-muted d-block mt-1 ms-3">Pedido confirmado y procesado</small>
                                </div>
                            </RenderIf>
                            <RenderIf isTrue={order.status === "ORDER_PICKED_UP"}>
                                <div class="status-item status-success">
                                    <span class="timeline-dot bg-success"></span>
                                    <span class="text-success fw-bold">Entregada</span>
                                    <small class="text-muted d-block mt-1 ms-3">Pedido confirmado y procesado</small>
                                </div>
                            </RenderIf>

                            <div className='d-lg-none d-flex justify-content-end'>
                                <button className='btn btn-small fw-semibold text-primary-emphasis bg-primary-subtle' onClick={() => setIsCollapsed(true)}><i class="fa-regular fa-eye"></i> Ver más</button>
                            </div>
                        </label>

                    </div>

                </React.Fragment>

            ))
        }

        return list
    }

    //Function product order template 
    const productOrdersTemplate = (products, platform) => {


        const list = products.map((product, idx) =>
            <>
                <div className="d-flex text-muted pt-3">
                    {/* <img className="bd-placeholder-img flex-shrink-0 me-2 rounded" 
                // src="https://es.123rf.com/photo_64365800_el-icono-de-la-foto-imagen-e-imagen-s%C3%ADmbolo-de-fotos-ilustraci%C3%B3n-del-vector-flat.html"
                 width="32" height="32" aria-label="Placeholder: 32x32" preserveAspectRatio="xMidYMid slice" focusable="false" /> */}
                    <div className="pb-3 mb-0 small lh-sm w-100 border-bottom">
                        <div className='d-flex justify-content-between align-items-center'>
                            <div className="product-header">
                                {/* Segments  */}
                                <RenderIf isTrue={platform === "PEDIDOSYA"}>
                                    {product.name}

                                </RenderIf>

                                <RenderIf isTrue={platform === "UBER_EATS"}>
                                    {product.title}
                                </RenderIf>
                                {/* Selct Option  */}
                            </div>

                            <div className='d-flex justify-content-end gap-1 '>
                                <span className='badge info-badge bg-primary rounded-pill'>Cantidad: {product.quantity}</span>
                                <RenderIf isTrue={platform === "PEDIDOSYA"}>
                                    <span className='badge info-badge bg-success rounded-pill'>Precio:  ${product?.paidPrice || "No registrado"}</span>

                                </RenderIf>
                                <RenderIf isTrue={platform === "UBER_EATS"}>
                                    <span className='badge info-badge bg-success rounded-pill'>Precio:  ${product.price?.total_price?.formatted_amount || "No registrado"}</span>

                                </RenderIf>
                            </div>
                        </div>

                        <span className="d-flex flex-wrap gap-2 mb-2">

                            {/* 🔔 PROMO BADGE */}
                            {platform === 'UBER_EATS' && discountAllocation[idx] > 0 && (
                                <span className="badge info-badge bg-warning text-dark promo-badge">
                                    Promo: -${centsToUSD(discountAllocation[idx] || 0)}
                                </span>
                            )}

                            {platform === "PEDIDOSYA" && discountAllocation[idx] > 0 && (
                                <span className="badge info-badge bg-warning text-dark promo-badge">
                                    Promo: -${discountAllocation[idx]}
                                </span>
                            )}
                        </span>
                        {/* Comment  */}
                        <RenderIf isTrue={platform === "PEDIDOSYA" && product.comment}>
                            {/* <span className="d-block">
                                <span className='mx-1 badge bg-light text-dark'>Nota del producto: {product.comment}</span>
                            </span> */}

                            <div className="note-section">
                                <small className="d-block mb-0">
                                    <i className="bi bi-pencil-square me-2"></i>
                                    <strong>Nota:</strong> {product.comment}
                                </small>
                            </div>
                        </RenderIf>

                        {/* Segments  */}
                        <RenderIf isTrue={platform === "UBER_EATS" && product.selected_modifier_groups && product.selected_modifier_groups.length > 0}>
                            {segmentsProductTemplate(product.selected_modifier_groups || [], platform)}
                        </RenderIf>

                        <RenderIf isTrue={platform === "PEDIDOSYA" && product.selectedToppings && product.selectedToppings.length > 0}>
                            {segmentsProductTemplate(product.selectedToppings || [], platform)}
                        </RenderIf>

                        <RenderIf isTrue={platform === "PEDIDOSYA" && product.selectedChoices && product.selectedChoices.length > 0}>
                            {segmentsProductTemplate(product.selectedChoices || [], platform)}
                        </RenderIf>


                    </div>
                </div>



            </>
        )

        return list
    }


    //Function segment order template 
    const segmentsProductTemplate = (segments, platform) => {
        const list = segments.map(segment => (
            <>
                {/** Segment list transaction details  */}
                <div className="d-flex text-muted">
                    <div className="mb-0 small lh-sm w-100">
                        <RenderIf isTrue={platform === "UBER_EATS"}>
                            <div className="d-flex justify-content-between">
                                {/* Segments  */}
                                <strong className="text-black h6">{segment.title}</strong>
                            </div>
                            {itemsProductTemplate(segment.selected_items || [], platform)}
                        </RenderIf>

                        <RenderIf isTrue={platform === "PEDIDOSYA" && segment.children && segment.children.length > 0}>
                            <div className="d-flex align-items-center">
                                {/* Segments  */}
                                <span className="text-primary h6 fw-semibold"> {segment.name}: </span>
                                <span className='ms-2'> {itemsProductTemplate(segment.children || [], platform)}</span>
                            </div>

                        </RenderIf>

                    </div>
                </div>
            </>
        ));

        return list
    }

    //Function item order template 
    const itemsProductTemplate = (items, platform) => {
        const list = items.map(item => (
            <>
                {/** Segment list transaction details  */}
                <div className="d-flex text-muted pt-3">
                    <div className="pb-3 mb-0 small lh-sm w-100">
                        <div className="d-flex justify-content-between">
                            <RenderIf isTrue={platform === 'UBER_EATS'}>
                                {/* Segments  */}
                                <strong className="text-black h6 mb-1">{item.title} x  {item.quantity}</strong>
                            </RenderIf>
                            <RenderIf isTrue={platform === 'PEDIDOSYA'}>
                                <strong className="text-black h6 mb-1">{item.name} - ${item.price} x  {item.quantity}</strong>
                            </RenderIf>

                        </div>
                    </div>
                </div>
            </>
        ));
        return list
    }

    useEffect(() => {
        setUnlinkedProducts([...unlinkedProducts])
        setUnlinkedItems([...unlinkedItems])
        setUnlinkedSegments([...unlinkedSegments])
        setCheckUnlinkedProducts(false)
    }, [checkUnlinkedProducts])

    //Order details template 
    const orderDetailsTemplate = () => {
        const isUber = orderDetails.platform === 'UBER_EATS';
        const totalPromoCents = isUber
            ? orderDetails?.payment?.charges?.total_promo_applied?.amount || 0
            : 0;
        const disableApprovePickup =
            orderDetails.platform === "ECOMMERCE" &&
            orderDetails?.is_scheduled === true &&
            pickupGate.isLocked;
        return <>
            <RenderIf isTrue={orderDetails.platform === "PEDIDOSYA"}>
                <div className="d-flex justify-content-between position-sticky top-0 z-3 bg-white">
                    <div className="h5 mt-1 text-primary fw-bold">
                        Orden #{orderDetails.shortCode}
                    </div>

                    <RenderIf isTrue={orderDetails.status === "pending"}>
                        <div className='d-flex justify-content-start border-bottom mt-2'>
                            <div>
                                <button className="btn btn-success btn-sm"
                                    disabled={isOrderProcessing(getProcessingOrderKey(orderDetails))}
                                    onClick={async () => {
                                        const orderKey = getDeliveryAcceptanceKey(orderDetails);
                                        const processingOrderKey = getProcessingOrderKey(orderDetails) || orderKey;

                                        if (!orderKey) return;
                                        if (pendingAcceptRef.current.has(orderKey)) return;
                                        if (isOrderProcessing(processingOrderKey)) return;

                                        pendingAcceptRef.current.add(orderKey);
                                        clearAutoAcceptTimer(orderDetails);
                                        markOrderAsProcessing(processingOrderKey);
                                        try {
                                            const toRegister = {
                                                order_id: orderDetails.transaction_code || orderDetails.pre_order_code || orderDetails.order_id,
                                                platform: "PEDIDOSYA",
                                                metadata: orderDetails,
                                                fulfillment_type: orderDetails.fulfillment_type || "delivery"
                                            };

                                            await onAcceptManualPY(toRegister);
                                        } finally {
                                            pendingAcceptRef.current.delete(orderKey);
                                            unmarkOrderAsProcessing(processingOrderKey);
                                        }
                                    }}>
                                    {isOrderProcessing(getProcessingOrderKey(orderDetails))
                                        ? "Procesando..."
                                        : "Aceptar"}
                                </button>
                            </div>
                            <div>
                                <button className="btn btn-danger btn-sm mx-2"
                                    onClick={() => {
                                        setOrderToReject(orderDetails);
                                        setRejectPlatform("PEDIDOSYA");
                                        setShowRejectModal(true);
                                    }}
                                >
                                    Rechazar
                                </button>
                            </div>
                        </div>
                    </RenderIf>


                    <RenderIf isTrue={orderDetails.status === "order_accepted" && orderDetails.platform === "PEDIDOSYA"}>
                        <div className='d-flex justify-content-start border-bottom mt-2'>
                            <div>
                                <button className="btn btn-success" onClick={() => { updatePedidosYaDeliveryOrder({ tokenOrder: orderDetails.token, status: "order_prepared" }) }}>
                                    Orden preparada
                                </button>
                            </div>
                        </div>
                    </RenderIf>

                    <RenderIf isTrue={orderDetails.status === "order_prepared" && orderDetails.platform === "PEDIDOSYA" && orderDetails.expeditionType === "pickup"}>
                        <div className='d-flex justify-content-start border-bottom mt-2'>
                            <div>
                                <button className="btn btn-primary" onClick={() => { updatePedidosYaDeliveryOrder({ tokenOrder: orderDetails.token, status: "order_picked_up" }) }}>
                                    Orden entregada
                                </button>
                            </div>
                        </div>
                    </RenderIf>
                </div>
                <div>
                    {/* Init Product */}
                    <div className=" bg-body rounded shadow-sm">
                        {/* Prodcut  */}
                        <div className='d-flex justify-content-center'>
                            <div>
                                <h6 className=" pb-2 mb-0 fw-bold ">Detalles de la orden</h6>
                            </div>


                        </div>
                        <div className='row'>
                            <div className='col-12 col-md-3'>
                                <div className="row mb-5">
                                    <CardInfo title={"Customer #" + orderDetails.customer?.id || ""} data={orderDetails.customer?.firstName || "" + " " + orderDetails.customer?.lastName || ""} />
                                    <CardInfo title="Store No." data={orderDetails.platformRestaurant?.id || ""} />

                                    <CardInfo title="Metodo de pago" data={orderDetails.payment?.remoteCode || ""} />
                                    <CardInfo title="Estado del pago" data={orderDetails.payment?.status || ""} />

                                    <CardInfo title="Scheduled Delivery Time" data={orderDetails.delivery?.expectedDeliveryTime ?
                                        new Intl.DateTimeFormat("en", {
                                            day: "2-digit",
                                            month: "short",
                                            hour: "2-digit",
                                            minute: "2-digit"
                                        }).format(new Date(orderDetails.delivery?.expectedDeliveryTime)) : "No registrada"
                                        || ""} />
                                    <CardInfo title="Hora de recogida" data={orderDetails.delivery?.riderPickupTime ?
                                        new Intl.DateTimeFormat("en", {
                                            day: "2-digit",
                                            month: "short",
                                            hour: "2-digit",
                                            minute: "2-digit"
                                        }).format(new Date(orderDetails.delivery?.riderPickupTime)) : "No registrada"
                                        || ""} />

                                    <CardInfo title="Delivery Method" data={orderDetails.delivery_method === 2 ? 'Home delivery' : 'Take Away'} />



                                    <CardInfo title="Customer Review" data="[-]" />
                                    <CardInfo title="Phone No." data={orderDetails.customer?.mobilePhone || ""} />

                                    <CardInfo title="Total de la orden" data={"$ " + orderDetails.price?.grandTotal || ""} />

                                    <RenderIf isTrue={orderDetails.platform === "PEDIDOSYA" && orderDetails.comments}>
                                        <CardInfo title="Notas de la orden" data={orderDetails.comments?.customerComment || ""} />
                                    </RenderIf>
                                </div></div>
                            <div className='col-12 col-md-9  border rounded-3'>
                                {/* Prodcut  */}
                                <div className='d-flex justify-content-start border-bottom mt-2'>
                                    <div>
                                        <h6 className=" pb-2 mb-0 fw-bold ">Productos de la Orden</h6>
                                    </div>
                                </div>
                                {productOrdersTemplate(orderDetails?.products || [], orderDetails.platform)}
                                {/* Buutton  */}
                            </div>
                        </div>
                    </div>
                    {/* End Product */}
                </div>
            </RenderIf>

            <RenderIf isTrue={orderDetails.platform === "UBER_EATS"}>
                <div className="d-flex justify-content-start">
                    <div className="h5 mt-1 text-primary fw-bold">
                        Order Client: {orderDetails.eater?.first_name || "Desconocido"}
                    </div>
                </div>
                <div>

                    {/* Init Product */}
                    <div className="my-3 p-3 bg-body rounded shadow-sm">
                        {/* Prodcut  */}
                        <div className='d-flex justify-content-start border-bottom mt-2'>
                            <div>
                                <h6 className=" pb-2 mb-0 fw-bold ">Detalles de la orden</h6>
                            </div>
                        </div>
                        <div className="row mb-5">
                            <CardInfo title={"Customer #" + 1} data={orderDetails.eaters?.[0]?.first_name || ""} />
                            <CardInfo title="Store" data={orderDetails.store?.name || ""} />

                            <CardInfo title="Pedido solicitado el" data={orderDetails?.placed_at || ""} />
                            <CardInfo title="Hora de recogida" data={orderDetails.delivery?.riderPickupTime || ""} />

                            <CardInfo title="Customer Rating" data={orderDetails.customer?.rating || ""} />
                            <CardInfo title="Delivery Method" data={orderDetails.delivery_method === 2 ? 'Home delivery' : 'Take Away'} />


                            <CardInfo title={orderDetails?.type === "DELIVERY_BY_UBER" ? 'Customer Address' : 'Pickup Adress'} data={orderDetails.expeditionType === "delivery" ? orderDetails.delivery.address : orderDetails.delivery?.address || ""} />
                            <CardInfo title="Phone No." data={orderDetails.eaters?.phone || "No registrado"} />

                            {totalPromoCents < 0 && (
                                <CardInfo title="Total de la orden" data={orderDetails.payment?.charges?.total?.formatted_amount || ""} />
                            )}
                            {/* 💥 TOTAL OF PROMO */}
                            {totalPromoCents > 0 && (
                                <CardInfo title="Total de la orden" data={`$${centsToUSD(totalPromoCents)}`} />
                            )}
                            <CardInfo title="Description" data="Description" />

                        </div>

                        {/* Prodcut  */}
                        <div className='d-flex justify-content-start border-bottom mt-2'>
                            <div>
                                <h6 className=" pb-2 mb-0 fw-bold ">Details</h6>
                            </div>
                        </div>
                        {productOrdersTemplate(orderDetails?.cart?.items || [], orderDetails.platform)}
                        {/* Buutton  */}
                        <RenderIf isTrue={orderDetails.status === "pending"}>
                            <div className='d-flex justify-content-start border-bottom mt-2'>
                                <div>
                                    <button
                                        className="btn btn-success btn-sm"
                                        disabled={isOrderProcessing(getProcessingOrderKey(orderDetails))}
                                        onClick={async () => {
                                            const orderKey = getDeliveryAcceptanceKey(orderDetails);
                                            const processingOrderKey = getProcessingOrderKey(orderDetails) || orderKey;

                                            if (!orderKey) return;
                                            if (pendingAcceptRef.current.has(orderKey)) return;
                                            if (isOrderProcessing(processingOrderKey)) return;

                                            pendingAcceptRef.current.add(orderKey);
                                            clearAutoAcceptTimer(orderDetails);
                                            markOrderAsProcessing(processingOrderKey);
                                            try {
                                                await updateUberEatsDeliveryOrder(orderDetails.id, branchoffice.id, "Acepted order", orderDetails.id, "Accepted order", false, "order_accepted", "", "",);
                                            } finally {
                                                pendingAcceptRef.current.delete(orderKey);
                                                unmarkOrderAsProcessing(processingOrderKey);
                                            }
                                        }}>
                                        Aceptar
                                    </button>
                                </div>
                                <div>
                                    <button className="btn btn-danger btn-sm mx-2"
                                        onClick={() => {
                                            setOrderToReject(orderDetails);
                                            setRejectPlatform("UBER_EATS"); // o "UBER_EATS"
                                            setShowRejectModal(true);
                                        }}
                                    >
                                        Rechazar
                                    </button>
                                </div>
                            </div>
                        </RenderIf>
                    </div>
                    {/* End Product */}
                </div>
            </RenderIf>

            <RenderIf isTrue={orderDetails.platform === "ECOMMERCE"}>
                <div className="d-flex justify-content-between position-sticky top-0 z-3 bg-white mb-3">
                    <div className="h5 mt-1 text-primary fw-bold d-flex align-items-center gap-2">
                        <span>Orden ecommerce #{orderDetails.transaction_code || orderDetails.order_id}</span>

                        <RenderIf isTrue={orderDetails.consolidation_group_id}>
                            <span className="badge bg-primary">Consolidada</span>
                        </RenderIf>
                    </div>

                    <RenderIf isTrue={orderDetails.status === "order_accepted_pending_invoice"}>
                        <div className="alert alert-info py-2">
                            Esta orden fue aprobada sin registrar y está pendiente de facturación.
                        </div>
                    </RenderIf>
                    <RenderIf isTrue={orderDetails.status === "order_accepted" && orderDetails.consolidation_group_id}>
                        <div className="alert alert-success py-2">
                            Esta orden ya fue consolidada y facturada en la transacción #{orderDetails.registered_transaction_code || "No registrada"}.
                        </div>
                    </RenderIf>

                    <div className="d-flex gap-2">
                        {/* aprobar y registrar */}
                        <RenderIf isTrue={orderDetails.status === "pending"}>
                            <button
                                className="btn btn-success btn-sm"
                                title="Aprobar y registrar"
                                disabled={isOrderProcessing(getProcessingOrderKey(orderDetails))}
                                onClick={async () => {
                                    const orderKey = getDeliveryAcceptanceKey(orderDetails);
                                    const processingOrderKey = getProcessingOrderKey(orderDetails) || orderKey;

                                    if (!orderKey) return;
                                    if (pendingAcceptRef.current.has(orderKey)) return;
                                    if (isOrderProcessing(processingOrderKey)) return;

                                    pendingAcceptRef.current.add(orderKey);
                                    clearAutoAcceptTimer(orderDetails);
                                    markOrderAsProcessing(processingOrderKey);
                                    try {
                                        const toRegister = {
                                            _id: orderDetails._id,
                                            order_id: orderDetails.transaction_code || orderDetails.pre_order_code || orderDetails.order_id || orderDetails._id,
                                            platform: "ECOMMERCE",
                                            metadata: orderDetails,
                                            fulfillment_type: orderDetails.fulfillment_type || "delivery"
                                        };

                                        await onAcceptManualPY(toRegister);
                                    } finally {
                                        pendingAcceptRef.current.delete(orderKey);
                                        unmarkOrderAsProcessing(processingOrderKey);
                                    }
                                }}
                            >
                                <i className="fa-solid fa-check"></i>{" "}
                                {isOrderProcessing(getProcessingOrderKey(orderDetails))
                                    ? "Procesando..."
                                    : "Aprobar y registrar"}
                            </button>

                            <button
                                className="btn btn-warning btn-sm"
                                disabled={isOrderProcessing(getProcessingOrderKey(orderDetails))}
                                onClick={async () => {
                                    const orderKey = getProcessingOrderKey(orderDetails);

                                    if (!orderKey) return;
                                    if (isOrderProcessing(orderKey)) return;

                                    markOrderAsProcessing(orderKey);
                                    try {
                                        await approveEcommerceWithoutRegister(orderDetails._id, orderDetails);
                                    } finally {
                                        unmarkOrderAsProcessing(orderKey);
                                    }
                                }}
                            >
                                <i className="fa-solid fa-receipt"></i>{" "}
                                {isOrderProcessing(getProcessingOrderKey(orderDetails))
                                    ? "Procesando..."
                                    : "Aprobar sin registrar"}
                            </button>

                            <div>
                                <button
                                    className="btn btn-danger btn-sm mx-2"
                                    onClick={() => {
                                        setOrderToReject(orderDetails);
                                        setRejectPlatform("ECOMMERCE");
                                        setShowRejectModal(true);
                                    }}
                                >
                                    Rechazar
                                </button>
                            </div>
                        </RenderIf>
                    </div>
                </div>

                <div className="bg-body rounded shadow-sm p-3">
                    <div className="row mb-3">
                        <div className="col-12 col-md-4">
                            <CardInfo title="Cliente" data={orderDetails.customer_name || orderDetails.client_name || "No registrado"} />
                            <CardInfo title="Teléfono" data={orderDetails.client_phone || orderDetails.customer_phone || "No registrado"} />
                            <CardInfo title="Correo electrónico" data={orderDetails.client_email || orderDetails.customer_email || "No registrado"} />
                            <CardInfo title="Ruc" data={orderDetails.ruc || "No registrado"} />
                            <CardInfo title="DV" data={orderDetails.dv || "No registrado"} />
                            <CardInfo title="Tipo de entrega" data={orderDetails.fulfillment_type || "pickup"} />
                            <CardInfo title="Fecha de creación" data={FormatDateTime(orderDetails.created_time, getOrderTz(orderDetails)) || "No registrada"} />
                            <RenderIf isTrue={orderDetails.fulfillment_type === "delivery"}>
                                <CardInfo
                                    title="Dirección"
                                    data={
                                        orderDetails.client_address
                                        || orderDetails.direction?.line
                                        || [orderDetails.direction?.house_num, orderDetails.direction?.name].filter(Boolean).join(", ")
                                        || "No especificada"
                                    }
                                />
                                <RenderIf isTrue={!!orderDetails.direction?.additional_info}>
                                    <CardInfo title="Referencia" data={orderDetails.direction?.additional_info} />
                                </RenderIf>
                                <RenderIf isTrue={orderDetails.platform === "ECOMMERCE" && Number(branchoffice?.delivery_whatsapp_enabled) === 1}>
                                    <button
                                        className="btn btn-outline-success btn-sm mb-2"
                                        disabled={sendingWhatsappManual}
                                        onClick={handleManualWhatsappResend}
                                    >
                                        <i className="fa-brands fa-whatsapp"></i>{" "}
                                        {sendingWhatsappManual ? "Enviando..." : "Reenviar por WhatsApp"}
                                    </button>
                                </RenderIf>
                            </RenderIf>
                            <CardInfo title="Metodo de pago" data={
                                paymentMethods.map(element => {
                                    if (element.id === orderDetails.paymethod) {
                                        return element.name
                                    }
                                })} />
                            <RenderIf isTrue={orderDetails.is_scheduled === true}>
                                <CardInfo title="Hora programada" data={FormatDateTime(orderDetails.scheduled_for, getOrderTz(orderDetails)) || "No registrada"} />
                                <CardInfo
                                    title="Ventana de retiro"
                                    data={
                                        orderDetails?.scheduled_window?.start && orderDetails?.scheduled_window?.end
                                            ? `${FormatDateTime(orderDetails.scheduled_window.start, getOrderTz(orderDetails))} — ${FormatDateTime(orderDetails.scheduled_window.end, getOrderTz(orderDetails))}`
                                            : "No registrada"
                                    }
                                />
                            </RenderIf>

                            <RenderIf isTrue={orderDetails.stand_name !== undefined}>
                                <CardInfo title="Stand" data={orderDetails.stand_name || "No registrado"} />
                            </RenderIf>

                            <RenderIf isTrue={orderDetails.event_name !== undefined && orderDetails.event_id !== undefined}>
                                <CardInfo title="Evento" data={orderDetails.event_name || "No registrado"} />
                            </RenderIf>
                            <RenderIf isTrue={orderDetails.registered_transaction_code !== undefined && orderDetails.registered_transaction_code !== null}>
                                <CardInfo
                                    title="Transacción registrada"
                                    data={orderDetails.registered_transaction_code || "No registrada"}
                                />
                            </RenderIf>

                            <RenderIf isTrue={orderDetails.consolidation_group_id !== undefined && orderDetails.consolidation_group_id !== null}>
                                <CardInfo
                                    title="Grupo de consolidación"
                                    data={orderDetails.consolidation_group_id || "No registrado"}
                                />
                            </RenderIf>
                            <CardInfo title="Total" data={`$ ${orderDetails.Total || orderDetails.subtotal || "0.00"}`} />
                        </div>
                        <div className="col-12 col-md-8 border rounded-3 p-2">
                            <h6 className="fw-bold mb-2">Productos de la orden</h6>
                            {(orderDetails.Orden || []).map((p, idx) => (
                                <div key={idx} className="d-flex justify-content-between border-bottom py-2">
                                    <div>
                                        <strong>{p.name}</strong>
                                        {p.segments && p.segments.length > 0 && (
                                            <div className="small text-muted">
                                                {p.segments.map((s, i) => (
                                                    <span key={i} className="badge bg-light text-dark me-1">
                                                        {s.segment_name}: {s.name}
                                                    </span>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                    <div className="text-end">
                                        <span className="badge bg-primary me-1">x{p.amount}</span>
                                        <span className="badge bg-success">${p.price}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </RenderIf>


        </>
    }

    useEffect(() => {
        // This effect enables a countdown only for ECOMMERCE pickup orders.
        const isEcom = orderDetails?.platform === "ECOMMERCE";
        //const isPickup = (orderDetails?.fulfillment_type || "").toLowerCase() === "pickup";
        const isPickup = orderDetails?.is_scheduled === true
        if (!isEcom || !isPickup) {
            setPickupGate({ isPickup: false, isLocked: false, secondsLeft: 0, unlockAtISO: null });
            return;
        }

        const unlockMoment = getPickupUnlockMoment(orderDetails);
        if (!unlockMoment) {
            // If there's no scheduled time/window, do not lock.
            setPickupGate({ isPickup: true, isLocked: false, secondsLeft: 0, unlockAtISO: null });
            return;
        }

        const tick = () => {
            const now = moment.tz(getOrderTz(orderDetails));
            const diffSec = Math.ceil(unlockMoment.diff(now, "seconds", true)); // can be negative
            const locked = diffSec > 0;

            setPickupGate({
                isPickup: true,
                isLocked: locked,
                secondsLeft: locked ? diffSec : 0,
                unlockAtISO: unlockMoment.toISOString()
            });
        };

        tick(); // immediate paint
        const id = setInterval(tick, 1000);

        return () => clearInterval(id);
    }, [orderDetails?.platform, orderDetails?.fulfillment_type, orderDetails?.scheduled_for, orderDetails?.scheduled_timezone, orderDetails?.scheduled_window?.start]);


    // Create the HTMLAudioElement once
    useEffect(() => {
        // Create audio element only once
        const audio = new Audio(newOrderSound);
        audio.loop = true;              // loop forever
        audio.preload = 'auto';
        audio.volume = 1.0;             // adjust if needed
        alarmAudioRef.current = audio;

        // Global "touch/click anywhere" to stop the alarm when active
        const stopOnUserInteraction = () => {
            if (alarmActive) {
                stopAlarm();
            }
        };
        window.addEventListener('pointerdown', stopOnUserInteraction, { passive: true });

        // Try to unlock audio right away instead of always waiting for a click. Once this
        // origin has enough engagement (the operator has clicked "Habilitar sonido" before on
        // this browser/device), Chrome's autoplay policy lets play() succeed without a gesture,
        // so the banner only shows up when the browser actually rejects the attempt.
        (async () => {
            try {
                await audio.play();
                audio.pause();
                audio.currentTime = 0;
                setAudioUnlocked(true);
                setShowAudioUnlock(false);
            } catch (err) {
                setAudioUnlocked(false);
                setShowAudioUnlock(true);
            }
        })();

        return () => {
            window.removeEventListener('pointerdown', stopOnUserInteraction);
            try { audio.pause(); } catch (_) { }
            alarmAudioRef.current = null;
        };
    }, []);

    // 📣 Call this when a new order arrives (PY) to start the alarm
    const startAlarm = async () => {
        const a = alarmAudioRef.current;
        if (!a) return;

        // Always restart from the beginning to ensure it's audible
        a.currentTime = 0;

        try {
            await a.play();               // Try play() — may be blocked until user gesture
            setAudioUnlocked(true);
            setShowAudioUnlock(false);
            setAlarmActive(true);
        } catch (err) {
            // Autoplay blocked — show unlock UI
            setAudioUnlocked(false);
            setShowAudioUnlock(true);
            setAlarmActive(false);
        }
    };

    // 🛑 Stop alarm on any screen touch or when you accept/reject
    const stopAlarm = () => {
        const a = alarmAudioRef.current;
        if (!a) return;
        try { a.pause(); } catch (_) { }
        a.currentTime = 0;
        setAlarmActive(false);
    };

    // Manual “tap to enable sound” (fix autoplay policy on first gesture)
    const handleUnlockAudio = async () => {
        const a = alarmAudioRef.current;
        if (!a) return;
        try {
            await a.play();
            a.pause();         // immediately pause; this just unlocks audio pipeline
            setAudioUnlocked(true);
            setShowAudioUnlock(false);
        } catch (_) {
            // Keep showing the unlock banner if fails
            setAudioUnlocked(false);
            setShowAudioUnlock(true);
        }
    };

    //Function to get the delivery orders
    const getDeliveryOrders = async (rangeKey = timeRange) => {
        try {
            const { minISO, maxISO } = buildRange(rangeKey);

            const res = await DeliveryOrdersFetchAPI.getDeliveryOrders(
                business_code,
                branchoffice_code,
                minISO,      // can be "" when ALL
                maxISO,      // can be "" when ALL
                "",
                "",
                token
            );

            setDeliveryOrders(res.data.data);
            setEventHandler(1);
        } catch (e) {
            setDeliveryOrders([]);
        }
    };


    //Function to update a pedidosya delivery order
    const updatePedidosYaDeliveryOrder = async (data) => {
        try {
            let response = await DeliveryOrdersFetchAPI.updatePedidosYaDeliveryOrder(data, token);
            //We check the response
            if (response.data !== undefined) {
                if (response.data.order.status === "ORDER_CANCELLED") {
                    ErrorAlert("Advertencia", "Orden ya cancelada", "warning")
                } else if (response.data.order.status === "order_accepted" && data.status === "order_accepted") {
                    registernewOrder("pedidos_ya");
                }
            }
        } catch (e) {
            ErrorAlert("Error", "Error al actualizar la orden", "error")
        }
    }

    //Function to update a uber eats delivery order
    const updateUberEatsDeliveryOrder = async (uber_order_id, branchoffice_id, reason, external_reference_id, commets, promotion, status, code, explanation) => {
        try {
            //update uber eats delivery order
            await DeliveryOrdersFetchAPI.updateUberEatsDeliveryOrder(uber_order_id, branchoffice_id, reason, external_reference_id, commets, promotion, status, code, explanation, token);
            //If the status is order_accepted we register the order
            if (status === "order_accepted") {
                //We register the order 
                registernewOrder("uber_eats");
            }
        } catch (e) {
            ErrorAlert("Error", "Error al actualizar la orden", "error")
        }
    }


    //Function to update a delivery order 
    const updateDeliveryOrder = async (delivery_order_id, toRegister, status) => {
        try {
            let resp;
            //We add to the data
            let data = { status: status };
            console.log("el to register del update delivery order", toRegister)

            //We register the order 
            if (status && status === "order_accepted") {
                //We register the order 
                resp = await registerFromEcommerceOrder(toRegister);
                if (resp?.__deliveryRegisterReused) return resp;
                //We add the response to the data
                data.response_registration = resp.data.data || {}

                try {
                    //We print the order with the new order id and transaction code, and the amount of items of the order
                    await printOrder(resp.data.data.order_id, resp.data.data.transaction_code, false, toRegister.metadata.Orden.length);
                } catch (_) { }
            } else {
                //To the rejection data we add the paymentmethod 
                toRegister.paymentmethod = paymentMethods.find(pm => pm.id === toRegister.paymethod) || "No especificadod";
                //We send the rejection email
                sendRejectedEmailOrder(toRegister.client_email, toRegister.transaction_code, toRegister);
                //We add the reason to the data
                data.rejection_reason = toRegister.rejection_reason || "No especificado";
                //We check the payment method of the order (powertranz)
                if (toRegister.paymethod && toRegister.paymethod == 40 && toRegister.paymenthod_integration_id == 5) {
                    //We make the refund on powertranz
                    let refundResp = await voidPowertranz(toRegister.EMVStreamResponse)
                    data.refund_info = refundResp || {};
                }

                //We cehck the payment method of the order (evertec placee to pay)
                if (toRegister.paymethod && toRegister.paymethod == 14 && toRegister.paymenthod_integration_id == 5) {
                    //We make the refund on evertech placetopay
                    let refundResp = await voidEvertech(toRegister);
                    data.refund_info = refundResp || {}
                }

                //We check the payment method of the order (Yappy)
                if (toRegister.paymethod && toRegister.paymethod == 6 && toRegister.paymenthod_integration_id == 2) {
                    //We make the refund on Yappy
                    let refundResp = await reversalYappyBtn(toRegister.yappy_transaction_id);
                    data.refund_info = refundResp || {}
                }

                //We check if the order was paid with Tilopay (the metadata of the order carries its order number)
                if (toRegister.tilopay_order_number) {
                    //We make the refund on Tilopay
                    let refundResp = await refundTilopay(toRegister.tilopay_order_number);
                    data.refund_info = refundResp || {}
                }

            }

            ///We update the delivery order
            await DeliveryOrdersFetchAPI.updateDeliveryOrder(token, delivery_order_id, data);

        } catch (e) {
            console.error("Error updating delivery order:", e);
            ErrorAlert("Error", "Error al actualizar la orden", "error")
        }
    }

    //Function to approve an ecommerce order without register (only update the delivery order)
    const approveEcommerceWithoutRegister = async (delivery_order_id, orderData) => {
        try {
            const user = JSON.parse(localStorage.getItem("user") || "{}");

            const data = {
                status: "order_accepted_pending_invoice",
                approved_without_register: true,
                invoice_pending: true,
                approved_at: new Date(),
                approved_by: user.id || null
            };

            await DeliveryOrdersFetchAPI.updateDeliveryOrder(token, delivery_order_id, data);

            SuccessAlert("Orden aprobada", "La orden fue aprobada sin registrar", "success");
        } catch (e) {
            console.error("Error approving ecommerce order without register:", e);
            ErrorAlert("Error", "No se pudo aprobar la orden sin registrar", "error");
        }
    };
    //Function to register a consolidated order from ecommerce orders
    const consolidateAndRegisterPendingOrders = async () => {
        try {
            if (selectedPendingInvoiceOrders.length === 0) {
                ErrorAlert("Advertencia", "Debes seleccionar al menos una orden", "warning");
                return;
            }

            const user = JSON.parse(localStorage.getItem("user") || "{}");
            const currentMachine = JSON.parse(localStorage.getItem("machine") || "{}");

            if (!user?.id) {
                ErrorAlert("Error", "No se encontró el usuario actual", "error");
                return;
            }

            if (!currentMachine?.id) {
                ErrorAlert("Error", "No se encontró la máquina actual", "error");
                return;
            }

            setIsConsolidatingOrders(true);

            const consolidateResp = await DeliveryOrdersFetchAPI.consolidateOrders(
                token,
                selectedPendingInvoiceOrders,
                user.id,
                currentMachine.id
            );

            const consolidatedPayload = consolidateResp?.data?.data?.payload;

            if (!consolidatedPayload) {
                throw new Error("No se recibió el payload consolidado");
            }

            // Try to auto-detect event from selected orders
            const selectedOrdersData = ecommercePendingInvoiceOrders.filter(order =>
                selectedPendingInvoiceOrders.includes(String(order._id))
            );

            const firstEventName =
                selectedOrdersData.find(o => o?.metadata?.event_name)?.metadata?.event_name ||
                selectedOrdersData.find(o => o?.raw_payload?.event_name)?.raw_payload?.event_name ||
                "";

            const firstEventId =
                selectedOrdersData.find(o => o?.metadata?.event_id)?.metadata?.event_id ||
                selectedOrdersData.find(o => o?.raw_payload?.event_id)?.raw_payload?.event_id ||
                null;

            setPendingConsolidatedPayload(consolidatedPayload);
            // Prepare editable products for invoice customization step
            setEditableConsolidatedProducts(
                (consolidatedPayload?.Orden || []).map((item, index) => ({
                    index,
                    name: item.name || "",
                    originalName: item.name || "",
                    amount: item.amount || 1,
                    price: item.price || 0,
                }))
            );
            // Move to invoice customization step
            setConsolidatedInvoiceStep(1);
            // Pre-fill invoice data with consolidated payload info (can be edited in the next step)
            setConsolidatedInvoiceName(consolidatedPayload?.client_name || "CONSUMIDOR FINAL");
            setConsolidatedInvoiceRuc(consolidatedPayload?.ruc || "0");
            setConsolidatedInvoiceDv(consolidatedPayload?.dv || "00");
            setConsolidatedDataResponse(false);
            setConsolidatedOptionalData(false);
            setConsolidatedEventName(firstEventName || consolidatedPayload?.event_name || "");
            setConsolidatedEventId(firstEventId || consolidatedPayload?.event_id || null);

            // Open invoice customization modal before register
            setShowConsolidatedInvoiceModal(true);

        } catch (e) {
            console.error("Error preparing consolidated invoice:", e);
            ErrorAlert(
                "Error",
                e?.response?.data?.error || e?.message || "No se pudo preparar la factura consolidada",
                "error"
            );
        } finally {
            setIsConsolidatingOrders(false);
        }
    };

    // Function to update the name of a consolidated product in the invoice customization step
    const updateEditableConsolidatedProductName = (index, value) => {
        setEditableConsolidatedProducts((prev) =>
            prev.map((item) =>
                item.index === index
                    ? { ...item, name: value }
                    : item
            )
        );
    };

    // Function to confirm the registration of the consolidated invoice after customization
    const confirmConsolidatedInvoiceRegistration = async () => {
        try {
            if (!pendingConsolidatedPayload) {
                ErrorAlert("Error", "No existe payload consolidado pendiente", "error");
                return;
            }

            const user = JSON.parse(localStorage.getItem("user") || "{}");

            setIsConsolidatingOrders(true);

            const payloadToRegister = {
                ...pendingConsolidatedPayload,
                client_name: consolidatedInvoiceName || "CONSUMIDOR FINAL",
                ruc: consolidatedInvoiceRuc || "0",
                dv: consolidatedInvoiceDv || "00",
                client_type: consolidatedClientType || pendingConsolidatedPayload.client_type || 2,
                Orden: (pendingConsolidatedPayload?.Orden || []).map((item, index) => {
                    const editedProduct = editableConsolidatedProducts.find(
                        (product) => product.index === index
                    );

                    return {
                        ...item,
                        name: editedProduct?.name || item.name,
                    };
                }),
            };

            if (consolidatedEventName) {
                payloadToRegister.event_name = consolidatedEventName;
            }

            if (consolidatedEventId) {
                payloadToRegister.event_id = consolidatedEventId;
            }

            const consolidatedOrderId = `CONSOLIDATED-${[...selectedPendingInvoiceOrders].sort().join("-")}`;
            const registerResp = await registerDeliveryOrderOnce(
                payloadToRegister,
                { order_id: consolidatedOrderId },
                consolidatedOrderId
            );
            const registerData = registerResp?.data?.data;

            if (!registerData) {
                throw new Error("No se recibió respuesta válida al registrar la orden consolidada");
            }

            await DeliveryOrdersFetchAPI.updateConsolidatedOrdersStatus(
                token,
                selectedPendingInvoiceOrders,
                registerData,
                user.id,
                `CONS-${registerData.order_code || registerData.transaction_code || Date.now()}`
            );

            try {
                const amountItems = (payloadToRegister?.Orden || []).length;
                await printOrder(
                    registerData.order_id,
                    registerData.transaction_code,
                    false,
                    amountItems
                );
            } catch (printErr) {
                console.warn("Print failed for consolidated order:", printErr);
            }

            SuccessAlert(
                "Orden consolidada registrada",
                "La factura consolidada fue registrada y vinculada con éxito",
                "success"
            );

            setShowConsolidatedInvoiceModal(false);
            setPendingConsolidatedPayload(null);
            setSelectedPendingInvoiceOrders([]);

            await getDeliveryOrders(timeRange);

        } catch (e) {
            console.error("Error registering consolidated invoice:", e);
            ErrorAlert(
                "Error",
                e?.response?.data?.error || e?.message || "No se pudo registrar la factura consolidada",
                "error"
            );
        } finally {
            setIsConsolidatingOrders(false);
        }
    };

    // Function to try scheduling auto-accept for a delivery order
    const tryScheduleAutoAccept = (order) => {
        if (!isAutoAcceptEnabled()) return;
        const deviceOk = machine && (String(machine.code) === String(getAutoAcceptDeviceId()));
        if (!deviceOk) return;

        const key = getDeliveryAcceptanceKey(order);
        if (!key) return;


        if (autoAcceptTimersRef.current.has(key)) return;
        if (pendingAcceptRef.current.has(key)) return;
        if (String(order.status || '').toLowerCase() !== 'pending') return;

        // ⏱ guarda deadline visible (10s desde ahora)
        const deadline = Date.now() + 10000;
        autoAcceptDeadlinesRef.current.set(key, deadline);
        setNowTick(Date.now());

        const timeoutId = setTimeout(async () => {
            autoAcceptTimersRef.current.delete(key);

            const latest = (() => {
                const arr = deliveryOrdersRef.current || [];
                const found = arr.find(o => getDeliveryAcceptanceKey(o) === key);
                return found || order;
            })();

            if (!latest || latest.status !== 'pending') {
                autoAcceptDeadlinesRef.current.delete(key);
                setNowTick(Date.now());
                return;
            }

            const okToAccept = canAutoAcceptAndRegister(latest);
            if (!okToAccept) {
                autoAcceptDeadlinesRef.current.delete(key);
                setNowTick(Date.now());
                return;
            }

            console.log("order para auto aceptar", order)
            if (pendingAcceptRef.current.has(key)) {
                autoAcceptDeadlinesRef.current.delete(key);
                setNowTick(Date.now());
                return;
            }

            pendingAcceptRef.current.add(key);

            try {
                //We check the platform 
                if (latest.platform !== undefined && latest.platform === "ECOMMERCE") {
                    //If is ecommerce we make the workflow of ecommerce
                    await updateDeliveryOrder(latest._id, latest, "order_accepted");
                } else if (latest.platform !== undefined && latest.platform === "UBER_EATS") {
                    await DeliveryOrdersFetchAPI.updateUberEatsDeliveryOrder(
                        latest.raw_payload?.id || latest.order_id,
                        branchoffice?.id,
                        "Accepted order",
                        latest.raw_payload?.store?.id || latest.store_id,
                        "Accepted order",
                        false,
                        "accept_pos_order",
                        "",
                        "",
                        token
                    );

                    await registerFromUberEatsOrder(latest);
                } else {
                    //If the platform is pedidosya we make the workflow of pedidosya
                    //We update the delivery order
                    await DeliveryOrdersFetchAPI.updatePedidosYaDeliveryOrder({
                        tokenOrder: latest.raw_payload?.token || latest.order_id || latest.token,
                        status: "order_accepted"
                    }, token);

                    // ✅ We register the auto accepted order from the latest order, not from orderDetails
                    await registerFromPedidosYaOrder(latest);
                }
            } catch (e) {
                console.error("Auto-accept error:", e);
            } finally {
                pendingAcceptRef.current.delete(key);
                autoAcceptDeadlinesRef.current.delete(key); // 🧹 quita el contador
                setNowTick(Date.now()); // fuerza re-render del timer
            }
        }, 10000);

        autoAcceptTimersRef.current.set(key, timeoutId);
    };


    const clearAutoAcceptTimer = (orderId) => {
        const key = typeof orderId === "string" ? orderId : getDeliveryAcceptanceKey(orderId);
        if (!key) return;

        const t = autoAcceptTimersRef.current.get(key);
        if (t) {
            clearTimeout(t);
            autoAcceptTimersRef.current.delete(key);
        }
        autoAcceptDeadlinesRef.current.delete(key); // 🧹
        setNowTick(Date.now()); // re-render
    };

    // On  manual click handler "Accept":
    const onAcceptManualPY = async (toRegister) => {
        stopAlarm(); // stop alarm immediately
        // cancel timer for this order (if any)
        console.log("aceptar manualmente", orderDetails)
        console.log("el to register del vaina manual", toRegister)
        //We check if the order is from ECOMMERCE
        if (toRegister !== undefined && toRegister.platform === "ECOMMERCE") {
            clearAutoAcceptTimer(toRegister);
            // mapping validation before manual acceptance on pedidosya
            const ok = canAutoAcceptAndRegister(toRegister);
            if (!ok) return;

            await updateDeliveryOrder(toRegister._id || orderDetails._id, toRegister, "order_accepted")
        } else {
            clearAutoAcceptTimer(orderDetails);
            // mapping validation before manual acceptance on pedidosya
            const ok = canAutoAcceptAndRegister({ platform: "PEDIDOSYA", raw_payload: orderDetails, status: "pending", order_id: orderDetails.token || orderDetails.code });
            if (!ok) return;

            await updatePedidosYaDeliveryOrder({ tokenOrder: orderDetails.token, status: "order_accepted" });
        }
    };

    //Hook Socket 
    useEffect(() => {
        // Connection with the sockets server
        socketRef.current = Socket({ "business_code": business_code, "branchoffice_code": branchoffice_code });
        // Evento de nueva orden PedidosYa
        socketRef.current.on("newPEDIDOSYAOrder", (data) => {
            console.log("Nueva orden PedidosYa:", data);
            setDeliveryOrders((prev) => [data, ...prev]);

            // ⏰ Start file alarm until user touches the screen
            startAlarm();
            tryScheduleAutoAccept(data);
        });

        // Event of new Uber Eats order
        socketRef.current.on("newUBER_EATSOrder", (data) => {
            const order = data?.orderDetails || data?.order || data;
            console.log("Nueva orden Uber Eats:", order);
            setDeliveryOrders((prev) => [order, ...prev]);
            tryScheduleAutoAccept(order);
            // ⏰ Start file alarm until user touches the screen
            startAlarm();
        });

        //Event of new Ecommerce order 
        socketRef.current.on("newECOMMERCEOrder", (data) => {
            console.log("Nueva transaccion ecommerce", data);
            setDeliveryOrders((prev) => [data, ...prev]);
            startAlarm();

            // 👇 We try to auto accept 
            tryScheduleAutoAccept(data);

        })

        // Event of update PedidosYa
        socketRef.current.on("updatePedidosYaStatusOrder", (data) => {
            console.log("Actualización de PedidosYa:", data);

            setDeliveryOrders((prev) => {
                const index = prev.findIndex((order) => order.order_id === data.order.order_id);
                if (index === -1) {
                    console.log("Order not found", data.order.order_id);
                    return prev;
                }

                const updated = [...prev];
                updated[index] = {
                    ...updated[index],
                    status: data.order.status,
                };

                setOrderDetails({
                    ...data.order.raw_payload,
                    platform: data.order.platform,
                    status: data.order.status,
                });
                //playBeep();
                SuccessAlert("Actualización de la orden", "La orden fue actualizada con éxito", "success");

                return updated;
            });
            //We clear the timer for this order
            clearAutoAcceptTimer(data.order.order_id);
            stopAlarm(); // stop alarm on any status update received

        });

        // Event of update Uber Eats
        socketRef.current.on("updateUberEatsStatusOrder", (data) => {
            const orderUpdated = data.orderDetails !== undefined ? data.orderDetails : data.order;

            setDeliveryOrders((prev) => {
                const index = prev.findIndex((order) => order.order_id === orderUpdated.order_id);
                if (index === -1) {
                    console.log("Order not found", orderUpdated.order_id);
                    return prev;
                }

                const updated = [...prev];
                updated[index] = {
                    ...updated[index],
                    status: orderUpdated.status,
                };

                setOrderDetails({
                    ...orderUpdated.raw_payload,
                    platform: orderUpdated.platform,
                    status: orderUpdated.status,
                });
                //playBeep();
                SuccessAlert("Actualización de la orden", "La orden fue actualizada con éxito", "success");

                return updated;
            });
            stopAlarm();
        });

        //Event of update Ecommerce order
        socketRef.current.on("delivery_order_updated", (data) => {
            console.log("Actualización de orden ecommerce:", data);

            setDeliveryOrders((prev) => {
                const index = prev.findIndex((order) => order._id === data._id);
                if (index === -1) {
                    console.log("Order not found", data.order_id);
                    return prev;
                }
                const updated = [...prev];
                updated[index] = {
                    ...updated[index],
                    status: data.status,
                };

                // Same field set as the manual row-click handler below - data.metadata only carries
                // the invoice-resolved client_name (can be "CONSUMIDOR FINAL" for guest orders),
                // while the real contact name lives in the top-level customer_name/customer_phone.
                // Without these, an auto-approval overwrites orderDetails and the Cliente card falls
                // back to "CONSUMIDOR FINAL" until the order is clicked again.
                setOrderDetails({
                    ...data.metadata,
                    platform: data.platform,
                    status: data.status,
                    fulfillment_type: data.fulfillment_type,
                    store_name: data.store_name,
                    customer_name: data.customer_name,
                    customer_phone: data.customer_phone,
                    order_id: data.order_id,
                    _id: data._id,
                    registered_transaction_code: data.registered_transaction_code,
                    registered_order_id: data.registered_order_id,
                    consolidation_group_id: data.consolidation_group_id,
                    invoice_pending: data.invoice_pending,
                    approved_without_register: data.approved_without_register,
                });
                //playBeep();
                SuccessAlert("Actualización de la orden", "La orden fue actualizada con éxito", "success");

                return updated;
            })

            //We clear the timer for this order
            clearAutoAcceptTimer(data);
            stopAlarm(); // stop alarm on any status update received
        });

        //Event of email result 
        socketRef.current.on("orderEmailNotifyResult", (data) => {
            console.log("the email response", data);
        })

        //Disconnect the socket when the component unmounts
        return () => {
            try { socketRef.current.disconnect(); } catch { }
            socketRef.current = null;
        };
    }, []);

    useEffect(() => {
        return () => {
            autoAcceptTimersRef.current.forEach((t) => clearTimeout(t));
            autoAcceptTimersRef.current.clear();
            autoAcceptDeadlinesRef.current.clear();
            pendingAcceptRef.current.clear();
        };
    }, []);

    //Hook to keep the printers ref updated
    useEffect(() => {
        printersRef.current = printers;
    }, [printers]);

    //Hook to keep the delivery orders ref updated for delayed auto-accept callbacks
    useEffect(() => {
        deliveryOrdersRef.current = deliveryOrders;
    }, [deliveryOrders]);

    //Hook to get the delivery orders
    useEffect(() => {
        //We get the delivery orders
        getDeliveryOrders();
        getPrinter();
        getConfigParams();
    }, []);

    //Hook to get the delivery orders when the time range changes
    useEffect(() => {
        getDeliveryOrders(timeRange);
    }, [timeRange]);

    //Hook to force the set the delivery orders
    useEffect(() => {
        setDeliveryOrders([...deliveryOrders]);
        setEventHandler(0);
    }, [eventHandler]);

    // Hook to validate the session
    useEffect(() => {
        (async () => {
            try {
                await validSession()
            } catch (err) {
                console.log(err);
            }
        })();
    }, []);


    /********************** REGISTER ORDER ************************/
    const registernewOrder = async (orderType) => {
        const smartpayGroups = JSON.parse(localStorage.getItem('generalData') || '[]')?.[0]?.data?.groups || [];
        const smartpaySegments = JSON.parse(localStorage.getItem('generalData') || '[]')?.[0]?.data?.externalDeliverySegments || [];
        const smartpayItems = JSON.parse(localStorage.getItem('generalData') || '[]')?.[0]?.data?.externalDeliveryItems || [];
        let responseRegister = null;
        const findSmartPayProduct = (externalId) =>
            smartpayGroups.find((g) => g.externalIntegrationIds?.some((e) => e.external_id === externalId));

        const findMappedSegment = (external_id) =>
            smartpaySegments.find(s => s.external_id === external_id);

        const findMappedItem = (external_id) =>
            smartpayItems.find(i => i.external_id === external_id);

        const pedidosYaHasVAT = orderType === "pedidos_ya" && hasPedidosYaVAT(orderDetails?.price);
        const pedidosYaSubtotal = Number(orderDetails?.price?.subTotal || 0);
        const pedidosYaITBMS = pedidosYaHasVAT ? pedidosYaSubtotal * 0.07 : 0;
        const pedidosYaTotal = pedidosYaHasVAT
            ? pedidosYaSubtotal + pedidosYaITBMS
            : Number(orderDetails?.price?.grandTotal || 0);

        let orden = [];
        //We make the products array to register
        if (orderType !== "pedidos_ya") {
            orden = orderDetails.cart.items.map((product, index) => {
                // 🔹 Product: Uber check id; if is SMARTPAY-<N>, we use it 
                const directGroupId = getSmartpayDirectId(product);
                const mappedProduct = directGroupId
                    ? { is_combo: false, group_id: directGroupId, combo_id: null, image_url: "", description: "" }
                    : findSmartPayProduct(product.external_data || product.id || product.title);

                const discountCents = discountAllocation[index] || 0;
                if (!mappedProduct) return null;

                const modifiersFinal = [];
                const modifiers = product.selected_modifier_groups || [];

                modifiers.forEach(mod => {
                    // 🔹 Segment: Uber group.id it can come with SMARTPAY-<N> (sometimes in id, not in remoteCode)
                    const directSegmentId = getSmartpayDirectId(mod);
                    const mappedSegment = directSegmentId
                        ? { segment_id: directSegmentId }
                        : findMappedSegment(mod.external_data || mod.id)
                    if (!mappedSegment) return;

                    (mod.selected_items || []).forEach(item => {
                        // 🔹 Item: Uber item.id could be SMARTPAY-<N>
                        const directItemId = getSmartpayDirectId(item);
                        const mappedItem = directItemId
                            ? { item_id: directItemId }
                            : findMappedItem(item.external_data || item.id);
                        if (!mappedItem) return;

                        modifiersFinal.push({
                            name: item.title,
                            img: item.image_url || "",
                            description: item.description || "",
                            item_id: mappedItem.item_id,
                            segment_id: mappedSegment.segment_id,
                            price: item.price.unit_price.amount / 100,
                            external_reference: null,
                            amount: item.quantity || 1,
                            segment_name: mod.title,
                            cantidadItem: item.quantity || 1,
                            item: {
                                name: item.title,
                                img: item.image_url || "",
                                description: item.description || "",
                                item_id: mappedItem.item_id,
                                segment_id: mappedSegment.segment_id,
                                price: item.price.unit_price.amount / 100,
                                external_reference: null,
                                amount: item.quantity || 1
                            }
                        });
                    });
                });

                return {
                    group_id: mappedProduct.is_combo ? null : mappedProduct.group_id,
                    combo_id: mappedProduct.is_combo ? mappedProduct.combo_id : null,
                    taxes: [{ tax_id: 4, tax: "0%", taxtValue: 0, dTasaITBMSValue: "00", percentage: "0%", total: 0 }],
                    name: product.title,
                    img: mappedProduct.image_url || "",
                    price: (product.price.unit_price.amount / 100),
                    description: mappedProduct.description || "",
                    group_type: "infinite",
                    preparation: 0,
                    amount: product.quantity,
                    delivery_type: "delivery",
                    note: product.comment || "",
                    unit_discount: discountCents > 0 ? discountCents / product.quantity / 100 : 0,
                    discount: discountCents / 100,
                    segments: modifiersFinal,
                    DetalleSegmentos: modifiersFinal,
                    segments_string: "" + product.quantity + "" + (mappedProduct.group_id || "") + modifiersFinal.map(m => m.segment_id + "" + m.item_id).join("")
                };
            }).filter(Boolean);

        } else {
            orden = orderDetails.products.map((product, index) => {
                const directGroupId = parseSmartpayId(product?.remoteCode);
                let price = product.unitPrice || 0;

                const mappedProduct = directGroupId
                    ? { is_combo: false, group_id: directGroupId, combo_id: null, image_url: "", description: "" }
                    : findSmartPayProduct(product.id || product.name);

                const discountCents = discountAllocation[index] || 0;
                if (!mappedProduct) return null;

                const baseProductPrice = Number(product.unitPrice || 0);
                const productTax = pedidosYaHasVAT ? buildPanamaTax(baseProductPrice) : {
                    tax_id: 4,
                    tax: "0%",
                    taxtValue: 0,
                    dTasaITBMSValue: "00",
                    percentage: "0%",
                    total: 0
                };

                const modifiersFinal = [];
                const modifiers = [
                    ...(product.selectedToppings || []),
                    ...(product.selectedChoices || [])
                ];

                modifiers.forEach(mod => {
                    const directSegmentId = parseSmartpayId(mod?.remoteCode);
                    const mappedSegment = directSegmentId
                        ? { segment_id: directSegmentId }
                        : findMappedSegment(mod.id);
                    if (!mappedSegment) return;

                    (mod.children || []).forEach(item => {
                        const directItemId = parseSmartpayId(item?.remoteCode);
                        const mappedItem = directItemId
                            ? { item_id: directItemId }
                            : findMappedItem(item.id);
                        if (!mappedItem) return;
                        //We add the price of the item to the product price
                        if (item.price) {
                            let Itemprice = typeof item.price === "string" ? parseFloat(item.price) * (item.quantity || 1) : item.price * (item.quantity || 1);
                            let productPrice = typeof price === "string" ? parseFloat(price) : price
                            price = productPrice += Itemprice;
                        }
                        //We create the modifier object
                        modifiersFinal.push({
                            name: item.name,
                            img: item.image_url || "",
                            description: item.description || "",
                            item_id: mappedItem.item_id,
                            segment_id: mappedSegment.segment_id,
                            price: item.price || 0,
                            branchoffice_id: branchoffice.id,
                            external_reference: null,
                            amount: item.quantity || 1,
                            segment_name: mod.name,
                            cantidadItem: item.quantity || 1,
                            item: {
                                name: item.name,
                                img: item.image_url || "",
                                description: item.description || "",
                                item_id: mappedItem.item_id,
                                segment_id: mappedSegment.segment_id,
                                price: item.price || 0,
                                branchoffice_id: branchoffice.id,
                                external_reference: null,
                                amount: item.quantity || 1
                            }
                        });
                    });
                });

                return {
                    group_id: mappedProduct.is_combo ? null : mappedProduct.group_id,
                    combo_id: mappedProduct.is_combo ? mappedProduct.combo_id : null,
                    taxes: [productTax],
                    name: product.name,
                    img: mappedProduct.image_url || "",
                    price: price,
                    description: mappedProduct.description || "",
                    group_type: "infinite",
                    preparation: 0,
                    amount: product.quantity,
                    delivery_type: "delivery",
                    note: product.comment || "",
                    unit_discount: discountCents,
                    discount: discountCents,
                    segments: modifiersFinal,
                    DetalleSegmentos: modifiersFinal,
                    segments_string: "" + product.quantity + "" + mappedProduct.group_id + modifiersFinal.map(m => m.segment_id + "" + m.item_id).join("")
                };
            }).filter(Boolean);

        }

        const payload = {
            user_id: JSON.parse(localStorage.getItem('user')).id,
            Orden: orden,
            client_name: orderDetails.eater ? orderDetails.eater.first_name + " " + (orderDetails.eater.last_name || "") : orderDetails.customer.firstName + " " + (orderDetails.customer.lastName || ""),
            id_Client: 0,
            ruc: "0",
            dv: "0",
            client_phone: orderDetails.eater ? orderDetails.eater.phone || "" : orderDetails.customer.mobilePhone || "",
            Descuento: (orderDetails.payment?.charges?.total_promo_applied?.amount || 0) / 100,
            Total: orderType !== "pedidos_ya" ? (orderDetails.payment.charges.total.amount / 100) : pedidosYaTotal,
            itbms: orderType === "pedidos_ya" ? pedidosYaITBMS : 0,
            subtotal: orderType !== "pedidos_ya" ? (orderDetails.payment.charges.sub_total.amount / 100) : pedidosYaSubtotal,
            machine_id: machine.id,
            taxes: orderType === "pedidos_ya" && pedidosYaHasVAT ? [{ tax_id: 1, percentage: '7%', total: pedidosYaITBMS }] : [{ tax_id: 4, percentage: '0%', total: 0 }],
            branchoffice_id: branchoffice.id,
            tipoOrden: "para llevar",
            paymethod: orderType === 'pedidos_ya' ? 37 : 38,
            paymethods: [],
            localizador: orderType === 'pedidos_ya' ? `PedidosYa# ${orderDetails.shortCode}` : `UberEats# ${orderDetails.display_id}`,
            tips: 0,
            paymenthod_integration_id: 3,
            delivery: {
                platform: orderDetails.platform,
                order_id: orderDetails.display_id !== undefined ? orderDetails.display_id : orderDetails.code,
            }
        };


        try {
            responseRegister = await registerDeliveryOrderOnce(
                payload,
                orderDetails
            );
            if (responseRegister?.__deliveryRegisterReused) return;
            SuccessAlert('Orden registrada', 'La orden fue registrada con éxito', 'success');


        } catch (err) {
            ErrorAlert('Error', 'Error al registrar la orden', 'error');
        }
        try {
            let amount_item = orderType !== 'pedidos_ya' ? orderDetails.cart.items.length : orderDetails.products.length;
            printOrder(responseRegister.data.data.order_id, responseRegister.data.data.transaction_code, false, amount_item);
        } catch (error) {

        }
    };

    // ✅ Function to register a new order in smartpay from pedidosya order
    const registerFromUberEatsOrder = async (order) => {
        const smartpayGroups = JSON.parse(localStorage.getItem('generalData') || '[]')?.[0]?.data?.groups || [];
        const smartpaySegments = JSON.parse(localStorage.getItem('generalData') || '[]')?.[0]?.data?.externalDeliverySegments || [];
        const smartpayItems = JSON.parse(localStorage.getItem('generalData') || '[]')?.[0]?.data?.externalDeliveryItems || [];

        const findSmartPayProduct = (externalId) =>
            smartpayGroups.find((g) => g.externalIntegrationIds?.some((e) => e.external_id === externalId));
        const findMappedSegment = (external_id) =>
            smartpaySegments.find(s => s.external_id === external_id);
        const findMappedItem = (external_id) =>
            smartpayItems.find(i => i.external_id === external_id);

        const raw = order?.raw_payload || order || {};
        const products = raw?.cart?.items || [];
        const promotions = raw?.payment?.promotions?.promotions || [];
        const fallbackPromo = Math.abs(raw?.payment?.charges?.total_promo_applied?.amount || 0);
        const allocation = buildDiscountMap(products, promotions, fallbackPromo);

        const orden = products.map((product, index) => {
            const directGroupId = getSmartpayDirectId(product);
            const mappedProduct = directGroupId
                ? { is_combo: false, group_id: directGroupId, combo_id: null, image_url: "", description: "" }
                : findSmartPayProduct(product.external_data || product.id || product.title);

            if (!mappedProduct) return null;

            const modifiersFinal = [];
            (product.selected_modifier_groups || []).forEach(mod => {
                const directSegmentId = getSmartpayDirectId(mod);
                const mappedSegment = directSegmentId
                    ? { segment_id: directSegmentId }
                    : findMappedSegment(mod.external_data || mod.id);

                if (!mappedSegment) return;

                (mod.selected_items || []).forEach(item => {
                    const directItemId = getSmartpayDirectId(item);
                    const mappedItem = directItemId
                        ? { item_id: directItemId }
                        : findMappedItem(item.external_data || item.id);

                    if (!mappedItem) return;

                    modifiersFinal.push({
                        name: item.title,
                        img: item.image_url || "",
                        description: item.description || "",
                        item_id: mappedItem.item_id,
                        segment_id: mappedSegment.segment_id,
                        price: (item.price?.unit_price?.amount || 0) / 100,
                        external_reference: null,
                        amount: item.quantity || 1,
                        segment_name: mod.title,
                        cantidadItem: item.quantity || 1,
                        item: {
                            name: item.title,
                            img: item.image_url || "",
                            description: item.description || "",
                            item_id: mappedItem.item_id,
                            segment_id: mappedSegment.segment_id,
                            price: (item.price?.unit_price?.amount || 0) / 100,
                            external_reference: null,
                            amount: item.quantity || 1
                        }
                    });
                });
            });

            const discountCents = allocation[index] || 0;

            return {
                group_id: mappedProduct.is_combo ? null : mappedProduct.group_id,
                combo_id: mappedProduct.is_combo ? mappedProduct.combo_id : null,
                taxes: [{ tax_id: 4, tax: "0%", taxtValue: 0, dTasaITBMSValue: "00", percentage: "0%", total: 0 }],
                name: product.title,
                img: mappedProduct.image_url || "",
                price: (product.price?.unit_price?.amount || 0) / 100,
                description: mappedProduct.description || "",
                group_type: "infinite",
                preparation: 0,
                amount: product.quantity,
                delivery_type: "delivery",
                note: product.comment || "",
                unit_discount: discountCents > 0 ? discountCents / (product.quantity || 1) / 100 : 0,
                discount: discountCents / 100,
                segments: modifiersFinal,
                DetalleSegmentos: modifiersFinal,
                segments_string: "" + product.quantity + "" + (mappedProduct.group_id || "") + modifiersFinal.map(m => m.segment_id + "" + m.item_id).join("")
            };
        }).filter(Boolean);

        const payload = {
            user_id: JSON.parse(localStorage.getItem('user')).id,
            Orden: orden,
            client_name: raw?.eater ? `${raw.eater.first_name || ""} ${raw.eater.last_name || ""}`.trim() : order?.customer_name || "",
            id_Client: 0,
            ruc: "0",
            dv: "0",
            client_phone: raw?.eater?.phone || order?.customer_phone || "",
            Descuento: (raw?.payment?.charges?.total_promo_applied?.amount || 0) / 100,
            Total: (raw?.payment?.charges?.total?.amount || 0) / 100,
            itbms: 0,
            subtotal: (raw?.payment?.charges?.sub_total?.amount || 0) / 100,
            machine_id: machine.id,
            taxes: [{ tax_id: 4, percentage: '0%', total: 0 }],
            branchoffice_id: branchoffice.id,
            tipoOrden: "para llevar",
            paymethod: 38,
            paymethods: [],
            localizador: `UberEats# ${raw?.display_id || order?.order_id || ""}`,
            tips: 0,
            paymenthod_integration_id: 3,
            delivery: {
                platform: "UBER_EATS",
                order_id: raw?.display_id || raw?.id || order?.order_id,
            }
        };

        try {
            const resp = await registerDeliveryOrderOnce(
                payload,
                order
            );
            if (resp?.__deliveryRegisterReused) return;
            SuccessAlert('Orden registrada', 'La orden fue registrada con Ã©xito', 'success');
            try {
                printOrder(resp.data.data.order_id, resp.data.data.transaction_code, false, orden.length);
            } catch (_) { }
        } catch (err) {
            console.error("Error registering Uber Eats order:", err);
            ErrorAlert('Error', 'Error al registrar la orden', 'error');
        }
    };

    const registerFromPedidosYaOrder = async (order) => {
        const smartpayGroups = JSON.parse(localStorage.getItem('generalData') || '[]')?.[0]?.data?.groups || [];
        const smartpaySegments = JSON.parse(localStorage.getItem('generalData') || '[]')?.[0]?.data?.externalDeliverySegments || [];
        const smartpayItems = JSON.parse(localStorage.getItem('generalData') || '[]')?.[0]?.data?.externalDeliveryItems || [];

        const findSmartPayProduct = (externalId) => smartpayGroups.find(g => g.externalIntegrationIds?.some(e => e.external_id === externalId));
        const findMappedSegment = (external_id) => smartpaySegments.find(s => s.external_id === external_id);
        const findMappedItem = (external_id) => smartpayItems.find(i => i.external_id === external_id);

        const products = order?.raw_payload?.products || [];
        const totalDescuento = parseFloat(order?.raw_payload?.price?.discountAmountTotal || 0);
        const allocation = buildDiscountMapFromPedidosYa(products, totalDescuento, 'unit');

        const pedidosYaHasVAT = hasPedidosYaVAT(order?.raw_payload?.price);
        const pedidosYaSubtotal = Number(order?.raw_payload?.price?.subTotal || 0);
        const pedidosYaITBMS = pedidosYaHasVAT ? pedidosYaSubtotal * 0.07 : 0;
        const pedidosYaTotal = pedidosYaHasVAT
            ? round2(pedidosYaSubtotal + pedidosYaITBMS)
            : Number(order?.raw_payload?.price?.grandTotal || 0);

        let orden = products.map((product, index) => {
            const directGroupId = parseSmartpayId(product?.remoteCode);
            let price = product.unitPrice || 0;

            // if not direct, we search by mapping as before
            const mappedProduct = directGroupId
                ? { is_combo: false, group_id: directGroupId, combo_id: null, image_url: "", description: "" }
                : findSmartPayProduct(product.id || product.name);

            if (!mappedProduct) return null;

            const baseProductPrice = Number(product.unitPrice || 0);
            const productTax = pedidosYaHasVAT ? buildPanamaTax(baseProductPrice) : {
                tax_id: 4,
                tax: "0%",
                taxtValue: 0,
                dTasaITBMSValue: "00",
                percentage: "0%",
                total: 0
            };

            const modifiersFinal = [];
            const modifiers = [
                ...(product.selectedToppings || []),
                ...(product.selectedChoices || [])
            ];
            modifiers.forEach(mod => {
                // 🔹 Segment: SMARTPAY-<N> in remoteCode => segment_id direct
                const directSegmentId = parseSmartpayId(mod?.remoteCode);
                const ms = directSegmentId
                    ? { segment_id: directSegmentId }
                    : findMappedSegment(mod.id);
                if (!ms) return;
                (mod.children || []).forEach(item => {
                    // 🔹 Item: SMARTPAY-<N> in remoteCode => item_id direct
                    const directItemId = parseSmartpayId(item?.remoteCode);
                    const mi = directItemId
                        ? { item_id: directItemId }
                        : findMappedItem(item.id);

                    if (!mi) return;

                    if (item.price) {
                        const itemPrice = (typeof item.price === "string" ? parseFloat(item.price) : item.price) * (item.quantity || 1);
                        price = (typeof price === "string" ? parseFloat(price) : price) + itemPrice;
                    }
                    modifiersFinal.push({
                        name: item.name,
                        img: item.image_url || "",
                        description: item.description || "",
                        item_id: mi.item_id,
                        segment_id: ms.segment_id,
                        price: item.price || 0,
                        branchoffice_id: branchoffice.id,
                        external_reference: null,
                        amount: item.quantity || 1,
                        segment_name: mod.name,
                        cantidadItem: item.quantity || 1,
                        item: {
                            name: item.name,
                            img: item.image_url || "",
                            description: item.description || "",
                            item_id: mi.item_id,
                            segment_id: ms.segment_id,
                            price: item.price || 0,
                            branchoffice_id: branchoffice.id,
                            external_reference: null,
                            amount: item.quantity || 1
                        }
                    });
                });
            });

            const discount = allocation[index] || 0;

            return {
                group_id: mappedProduct.is_combo ? null : mappedProduct.group_id,
                combo_id: mappedProduct.is_combo ? mappedProduct.combo_id : null,
                taxes: [productTax],
                name: product.name,
                img: mappedProduct.image_url || "",
                price,
                description: mappedProduct.description || "",
                group_type: "infinite",
                preparation: 0,
                amount: product.quantity,
                delivery_type: "delivery",
                note: product.comment || "",
                unit_discount: discount,
                discount,
                segments: modifiersFinal,
                DetalleSegmentos: modifiersFinal,
                segments_string: "" + product.quantity + "" + mappedProduct.group_id + modifiersFinal.map(m => m.segment_id + "" + m.item_id).join("")
            };
        }).filter(Boolean);

        const payload = {
            user_id: JSON.parse(localStorage.getItem('user')).id,
            Orden: orden,
            client_name: order?.raw_payload?.customer ? `${order.raw_payload.customer.firstName || ""} ${order.raw_payload.customer.lastName || ""}`.trim() : "",
            id_Client: 0, ruc: "0", dv: "0",
            client_phone: order?.raw_payload?.customer?.mobilePhone || "",
            Descuento: 0,
            Total: pedidosYaTotal,
            itbms: pedidosYaITBMS,
            subtotal: pedidosYaSubtotal,
            machine_id: machine.id,
            taxes: pedidosYaHasVAT
                ? [{ tax_id: 1, percentage: '7%', total: pedidosYaITBMS }]
                : [{ tax_id: 4, percentage: '0%', total: 0 }],
            branchoffice_id: branchoffice.id,
            tipoOrden: "para llevar",
            paymethod: 37,
            paymethods: [],
            localizador: `PedidosYa# ${order?.raw_payload?.shortCode}`,
            tips: 0,
            paymenthod_integration_id: 3,
            delivery: { platform: 'PEDIDOSYA', order_id: order?.raw_payload?.shortCode || order?.order_id }
        };

        try {
            const resp = await registerDeliveryOrderOnce(
                payload,
                order
            );
            if (resp?.__deliveryRegisterReused) return;
            SuccessAlert('Orden registrada', 'La orden fue registrada con éxito', 'success');
            try {
                printOrder(resp.data.data.order_id, resp.data.data.transaction_code, false, orden.length);
            } catch (_) { }
        } catch (err) {
            ErrorAlert('Error', 'Error al registrar la orden', 'error');
        }
    };

    // Function to notify the branch's configured WhatsApp number (motorizados) with the delivery
    // order details + address + Maps link. Used both for the automatic send on approval and for
    // the manual "Reenviar por WhatsApp" contingency button. Never throws - a WhatsApp failure
    // should never block registering/displaying the order.
    const notifyDeliveryWhatsapp = async ({ branchoffice_id, order_code, transaction_code, client_name, client_phone, products, total, direction, client_address }) => {
        try {
            await WhatsappFetchAPI.sendDeliveryOrderNotification({
                branchoffice_id, order_code, transaction_code, client_name, client_phone,
                products, total, direction, client_address
            }, token);
        } catch (err) {
            console.error('No se pudo enviar la notificación de WhatsApp del pedido de delivery:', err);
        }
    };

    // Manual "contingency" resend, triggered from the order details panel button
    const handleManualWhatsappResend = async () => {
        try {
            setSendingWhatsappManual(true);
            const resp = await WhatsappFetchAPI.sendDeliveryOrderNotification({
                branchoffice_id: orderDetails.branchoffice_id || JSON.parse(localStorage.getItem('branchoffice') || '{}').id,
                order_code: orderDetails.order_id || orderDetails.code,
                transaction_code: orderDetails.registered_transaction_code || orderDetails.transaction_code,
                client_name: orderDetails.customer_name || orderDetails.client_name,
                client_phone: orderDetails.client_phone || orderDetails.customer_phone,
                products: orderDetails.Orden,
                total: orderDetails.Total || orderDetails.subtotal,
                direction: orderDetails.direction,
                client_address: orderDetails.client_address
            }, token);

            if (resp?.data?.sent === false) {
                ErrorAlert('Advertencia', 'Esta sucursal no tiene activado el envío por WhatsApp (configúralo en Sucursales).', 'warning');
            } else {
                SuccessAlert('Enviado', 'Se envió el pedido por WhatsApp.', 'success');
            }
        } catch (err) {
            console.error(err);
            ErrorAlert('Error', 'No se pudo enviar el pedido por WhatsApp', 'error');
        } finally {
            setSendingWhatsappManual(false);
        }
    };

    // Function to register orders from ecommerce
    const registerFromEcommerceOrder = async (orderDoc) => {
        const meta = orderDoc.metadata || {};
        const payload = {
            user_id: JSON.parse(localStorage.getItem('user')).id,
            Orden: meta.Orden || [],
            client_name: orderDoc.customer_name || meta.client_name || "Cliente ecommerce",
            ruc: meta.ruc || "0",
            dv: meta.dv || "0",
            client_phone: meta.client_phone || orderDoc.customer_phone || "",
            client_email: meta.client_email || orderDoc.customer_email || "",
            Descuento: meta.Descuento || 0,
            Total: meta.Total,
            itbms: meta.itbms || 0,
            taxes: meta.taxes || [],
            subtotal: meta.subtotal || meta.Total,
            machine_id: meta.machine_id || (JSON.parse(localStorage.getItem('machine') || '{}').id),
            branchoffice_id: meta.branchoffice_id || (JSON.parse(localStorage.getItem('branchoffice') || '{}').id),
            tipoOrden: meta.tipoOrden || (orderDoc.fulfillment_type === "delivery" ? "delivery" : "para llevar"),
            paymethod: meta.paymethod || 10,
            paymethods: meta.paymethods || [],
            transaction_code: meta.transaction_code || "",
            paymenthod_integration_id: meta.paymenthod_integration_id || 3,
            tips: meta.tips || 0,
            delivery: meta.delivery || { platform: "smartpay", value: meta.delivery?.value || 0 },
            direction: meta.direction || "",
            client_address: meta.client_address || meta.direction?.line || "",
            is_scheduled: meta.is_scheduled || false,
            scheduled_for: meta.scheduled_for || null,
            scheduled_window: meta.scheduled_window || { start: null, end: null },
            scheduled_timezone: meta.scheduled_timezone || null,
            EMVStreamResponse: meta.EMVStreamResponse || 0,
            evertechPaymentReference: meta.evertechPaymentReference || null,
            event_id: meta.event_id || null,
            event_name: meta.event_name || null,
            stand_name: meta.stand_name || null,
            pre_order_id: meta.pre_order_id || null,
            pre_order_code: meta.pre_order_code || null,
        };

        try {
            const resp = await registerDeliveryOrderOnce(
                payload,
                orderDoc,
                orderDoc?._id || orderDoc?.metadata?._id || orderDoc?.pre_order_id || orderDoc?.metadata?.pre_order_id
            );
            if (resp?.__deliveryRegisterReused) return resp;
            SuccessAlert("Orden registrada", "La orden de ecommerce fue registrada con éxito", "success");

            //In base of the registered order, we check the delivery platform 
            if (payload.delivery.platform === "tookan") {
                try {
                    await registerTookanOrder(payload.delivery.details, orderDoc.transaction_code)
                } catch (err) {
                    console.log(err)
                }
            } else if (payload.delivery.platform === "asap") {
                try {
                    await registerAsapOrder(payload.delivery.details, orderDoc.transaction_code);
                } catch (err) {
                    console.log(err);
                }
            } else if (payload.delivery.platform === "uber_direct") {
                try {
                    await registerUberDirectOrder(payload.delivery.details, orderDoc.transaction_code);
                } catch (err) {
                    console.log(err);
                }
            }



            //We emmit the event to send the email
            sendEmailOrder(orderDoc.customer_email, resp.data.data.order_code || orderDoc.order_id);

            //If it's a delivery order, we notify the branch's configured WhatsApp number (fire-and-forget)
            if (orderDoc.fulfillment_type === "delivery") {
                notifyDeliveryWhatsapp({
                    branchoffice_id: payload.branchoffice_id,
                    order_code: orderDoc.order_id || resp.data.data.order_code,
                    transaction_code: resp.data.data.transaction_code || payload.transaction_code,
                    client_name: payload.client_name,
                    client_phone: payload.client_phone,
                    products: payload.Orden,
                    total: payload.Total,
                    direction: payload.direction,
                    client_address: payload.client_address
                });
            }

            //We return the response of the order registered
            return resp;
        } catch (err) {
            console.error(err);
            ErrorAlert("Error", "No se pudo registrar la orden de ecommerce", "error");
        }
    };


    /****************Register DELIVERY PLATFORMS *****************************/
    //Function to register the asap order
    const registerAsapOrder = async (data, transaction_code) => {
        try {
            //We add some required fields 
            let orderData = {
                ...data,
                "order_id": "SmartPay-" + transaction_code
            };
            //We register the order with asap
            const response = await AsapFetchAPI.registerAsapOrder(localStorage.getItem("x-access-machine-token"), orderData);
            //We return the response of the asap order
            console.log("Asap order response", response);
            return response.data.asap_response
        } catch (err) {
            //We check which error is and show it
            if (err.response && err.response.data && err.response.data.error) {
                ErrorAlert(err.response.data.error, "Alerta", "warning");
            } else {
                ErrorAlert("No se pudo registrar la orden con Asap", "Alerta", "error")
            }
        }
    }

    //Function to register the tookan order 
    const registerTookanOrder = async (data, transaction_code) => {
        try {
            console.log("Register tookan order function");
            // Get current datetime in Panama timezone
            const now = moment().tz("America/Panama");

            // Calculate pickup = +20 min, delivery = +30 min
            const job_pickup_datetime = now.clone().add(20, "minutes").format("YYYY-MM-DD HH:mm:ss");
            const job_delivery_datetime = now.clone().add(30, "minutes").format("YYYY-MM-DD HH:mm:ss");

            //We add some required fields 
            let orderData = {
                ...data,
                "job_pickup_datetime": job_pickup_datetime,
                "job_delivery_datetime": job_delivery_datetime,
                "order_id": "SmartPay-" + transaction_code
            }

            //We register the order with tookan 
            const response = await TookanFetchAPI.registerTookanOrder(localStorage.getItem("x-access-machine-token"), orderData);

            //We return the response of the tookan order
            return response.data.task
        } catch (err) {
            console.log("en el tookan", err);
            //We check which error is and show it
            if (err.response && err.response.data && err.response.data.error) {
                ErrorAlert(err.response.data.error, "Alerta", "warning");
            } else {
                ErrorAlert("No se pudo registrar la orden con Tookan", "Alerta", "error")
            }
        }
    }

    //Function to register the uber direct order
    const registerUberDirectOrder = async (details, orderCode) => {
        try {
            const business = JSON.parse(localStorage.getItem("business") || "{}");
            const branchoffice = JSON.parse(localStorage.getItem("branchoffice") || "{}");
            const token = localStorage.getItem("x-access-machine-token");

            if (!details) {
                console.log("No Uber Direct details found");
                return;
            }

            const data = {
                business_id: business?.id,
                branchoffice_id: branchoffice?.id,
                order_id: orderCode,

                pickup_name: details.pickup_name,
                pickup_business_name: details.pickup_business_name || details.pickup_name,
                pickup_address: details.pickup_address,
                pickup_phone_number: details.pickup_phone_number,
                pickup_latitude: details.pickup_latitude,
                pickup_longitude: details.pickup_longitude,
                pickup_notes: details.pickup_notes || "",

                dropoff_name: details.dropoff_name,
                dropoff_business_name: details.dropoff_business_name || "",
                dropoff_address: details.dropoff_address,
                dropoff_phone_number: details.dropoff_phone_number,
                dropoff_latitude: details.dropoff_latitude,
                dropoff_longitude: details.dropoff_longitude,
                dropoff_notes: details.dropoff_notes || "",
                dropoff_seller_notes: details.dropoff_seller_notes || "",

                manifest_items: details.manifest_items || [],
                manifest_reference: details.manifest_reference || orderCode,
                manifest_total_value: details.manifest_total_value || 0,

                quote_id: details.quote_id,

                pickup_ready_dt: details.pickup_ready_dt,
                pickup_deadline_dt: details.pickup_deadline_dt,
                dropoff_ready_dt: details.dropoff_ready_dt,
                dropoff_deadline_dt: details.dropoff_deadline_dt,

                deliverable_action: details.deliverable_action || "deliverable_action_meet_at_door",
                undeliverable_action: details.undeliverable_action || "leave_at_door",

                requires_dropoff_signature: details.requires_dropoff_signature || false,
                requires_id: details.requires_id || false,
                tip: details.tip || 0,

                idempotency_key: details.idempotency_key || orderCode,
                external_store_id: details.external_store_id || String(branchoffice?.id || ""),
                external_id: details.external_id || orderCode,

                pickup_verification: details.pickup_verification || {
                    signature: false,
                    signature_requirement: {},
                    barcodes: [],
                    identification: {},
                    picture: false
                },

                dropoff_verification: details.dropoff_verification || {
                    signature: false,
                    signature_requirement: {},
                    barcodes: [],
                    pincode: {},
                    identification: {},
                    picture: false
                }
            };

            await UberDirectFetchAPI.createUberDirectOrder(token, data);

        } catch (err) {
            console.log("error register uber direct order", err);
        }
    };

    /**********SEND EMAIL*************/
    const sendEmailOrder = async (client_email, order_code) => {
        //We build the payload
        let payload = {
            token: localStorage.getItem('x-access-machine-token'),
            business_code: business_code,
            branchoffice_code: branchoffice_code,
            machine_code: machine.code,
            client_email: client_email,
            order_code: order_code
        }
        //We emmit an event to send the email
        socketRef.current.emit("orderEmailNotify", payload);
    }

    const sendRejectedEmailOrder = async (client_email, transaction_code, order) => {
        //We build the payload 
        let payload = {
            token: localStorage.getItem('x-access-machine-token'),
            business_code: business_code,
            branchoffice_code: branchoffice_code,
            branchoffice_id: branchoffice.id,
            client_email: client_email,
            transaction_code: transaction_code,
            order: order
        }
        //We emit the event to send the email
        socketRef.current.emit("orderRejectedEmailNotify", payload);
    }

    /************************************************************* */

    /************Reverse payments ***********************************/


    //Void powertranz
    const voidPowertranz = async (paymentInfo) => {
        let data = { "TransactionIdentifier": paymentInfo.TransactionIdentifier }

        try {

            let headers = {
                'x-access-token': token,
                'X-PowerTranz-Id': paymentInfo?.X_PowerTranz_Id,
                'X-PowerTranz-Password': paymentInfo?.X_PowerTranz_Password
            }
            const response = await PowetranzFetchAPI.void(data, headers);
            let approved = response.data.data.Approved;
            let responseVoidData = {}
            responseVoidData.powertranzResponse = response.data.data

            let datafilter = response.data.data
            const now = new Date(); // Gets current date and time
            const formattedDate = `${now.getDate().toString().padStart(2, '0')}/${(now.getMonth() + 1).toString().padStart(2, '0')}/${now.getFullYear()}`;
            const formattedTime = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`;
            responseVoidData.voucher = `\r\n        ***  POWERTRANZ  ***        \r\n\r\n        ***  ANULADO  ***        \r\n\r\nOrden:                       ${datafilter.OrderIdentifier.split("X")[0]}\r\nDATE: ${formattedDate}            ${formattedTime}\r\n\r\nDESCRIPTION:\r\n   ${datafilter.ResponseMessage}\r\nTOTAL:                      ${datafilter.TotalAmount} \r\n\r\n        ***  ANULADO  ***        \r\nSTATUS:                     APROVADO\r\nAUTH:                       ${datafilter.AuthorizationCode}\r\nTXID:\r\n${datafilter.TransactionIdentifier}\r\n\n           ****** FIN  ******            \r\n`;
            if (approved == true) {
                SuccessAlert("Transacción anulada", "La transacción fue anulada con éxito", "success")
            }

            return responseVoidData

        } catch (err) {
            let message = "No se aplico la devlucion."
            let title = "Error en la devolucion "
            let icon = "error"
            ErrorAlert(title, message, icon)
        }
    }


    //Void evertech
    const voidEvertech = async (paymentInfo) => {
        try {

            let secretKey, loginKey;
            //We get the machine payment methods
            let paymentMethods = await PaymentMethodFetchAPI.getPaymentMethod(paymentInfo.machine_id, token);
            //We get the data of evertech
            let paymentMethodIndex = paymentMethods.data.data.findIndex(element => element.payment === "Evertech");

            //We check that the payment method exist 
            if (paymentMethodIndex !== -1) {
                paymentMethods.data.data[paymentMethodIndex].params.forEach(param => {
                    switch (param.name) {
                        case "SECRET_KEY":
                            secretKey = param.value;
                            break;
                        case "LOGIN_KEY":
                            loginKey = param.value;
                            break;
                        default:
                            break;
                    }
                });
                //We make the refund 
                let evertechVoidResponse = await EvertechFetchAPI.returnEvertecEcommercePayment(secretKey, loginKey, paymentInfo.evertechPaymentReference, paymentInfo.Total, token);
                return evertechVoidResponse
            } else {
                ErrorAlert('Metodo de pago no asignado al ecommerce de esta transaccion', 'Metodo de pago no encontrado', 'warning');
            }
        } catch (err) {
            let message = "No se aplico la devlucion."
            let title = "Error en la devolucion "
            let icon = "error"
            ErrorAlert(title, message, icon)
        }
    }


    //Refund a tilopay payment: the server tries a reversal first and a refund if it is rejected (credentials never reach the POS)
    const refundTilopay = async (tilopay_order_number) => {
        try {
            let token = localStorage.getItem('x-access-machine-token');
            const response = await TilopayFetchAPI.refund({ order_number: tilopay_order_number }, token);
            let newVoucher = { EMVStreamResponse: "Transaccion reversada Tilopay #" + tilopay_order_number }
            return { newVoucher: newVoucher, response: response?.data?.data || {} }
        } catch (err) {
            let detail = err?.response?.data?.error || "No se aplico la devolucion."
            ErrorAlert("Error en la devolucion", detail + " Devuelve el dinero manualmente (Tilopay " + tilopay_order_number + ").", "error")
            return { failed: true, tilopay_order_number: tilopay_order_number, error: detail }
        }
    }

    //Reverse yappy btn 
    const reversalYappyBtn = async (yappy_transaction_id) => {
        try {
            let token = localStorage.getItem('x-access-machine-token');
            const response = await YappyFetchAPI.reverseYappyBtnTransaction({ yappy_transaction_id: yappy_transaction_id, params: [] }, token);
            let newVoucher = { EMVStreamResponse: "Transaccion reversada #" + yappy_transaction_id }
            return { newVoucher: newVoucher, response }
        } catch (err) {
            let message = "No se aplico la devlucion."
            let title = "Error en la devolucion "
            let icon = "error"
            ErrorAlert(title, message, icon)
        }
    }

    /**************************************************************** */
    //print order
    const printOrder = async (id_Orden_Imprimir, transaction_code, micros, amount_item) => {
        let type_ticket = ""
        let imprimir_comanda = ""
        let ip_print = "localhost"
        console.log("impresoras", printers)
        console.log("impresoras desde el ref", printersRef.current)
        if (localStorage.getItem("ip_printer") != "" && localStorage.getItem("ip_printer") != undefined && localStorage.getItem("ip_printer") != null) {
            ip_print = localStorage.getItem("ip_printer")
        }

        if (preOrderInvoice == true) {
            //type_ticket = "factura_precuenta"
            type_ticket = "factura"
            imprimir_comanda = "no"
        } else {
            type_ticket = "factura"
            imprimir_comanda = "si"
        }

        let arrayPrinters = []
        if (dataPreOrder.pre_Order == true) {
            printersRef.current.forEach((printer) => {
                if (printer.printer_type == "Tickets") {
                    arrayPrinters.push(printer)
                }
            });

        } else {
            printersRef.current.forEach((printer) => {
                arrayPrinters.push(printer)
            });
        }

        let JsonImprimir = [{
            "type_ticket": type_ticket,
            "Printers": arrayPrinters,
            "Nombre_maquina_impresora": infoPrinter.printer_ticket,
            "Nombre_cocina_impresora": infoPrinter.printer_comanda,
            "Nombre_zebra_impresora": infoPrinter.printer_zebra,
            "PRINTER_IP": infoPrinter.printer_ip,
            "Id_Orden_Imprimir": id_Orden_Imprimir,
            "token": localStorage.getItem('x-access-machine-token'),
            "transaction_code": transaction_code,
            "amount_item": amount_item,
            "imprimir_comanda": imprimir_comanda,
        }]

        try {
            const response_machine = await MachinesFetchAPI.getmachineByid(machine.id, localStorage.getItem('x-access-machine-token'));

            if (micros == true) {
                let dataRequestMicros = {
                    "body": JsonImprimir, "method": "POST", "url": "http://localhost:9090/impresion"
                }
                const response = await RequestAlohaFetchAPI.requestLocalIp(dataRequestMicros, response_machine.data.data.windows_ip)
            } else {
                if (ip_print == "localhost") {
                    const response = await PrinterFetchAPI.printOrder(ip_print, JsonImprimir, response_machine.data.data.windows_ip)
                } else {
                    const response = await PrinterFetchAPI.printByServerMiddle(ip_print, JsonImprimir)
                }
            }

            return true;
        } catch (err) {
            console.log(err);
            return false;
        }
    }

    /********************** Desing Setting layout ************************/
    // Leer el valor inicial desde localStorage o usar false por defecto
    const [reverseOrder, setReverseOrder] = useState(() => {
        const saved = localStorage.getItem('reverseOrder');
        return saved === 'true'; // convierte string a boolean
    });

    const [isCollapsed, setIsCollapsed] = useState(() => {
        const saved = localStorage.getItem("isCollapsed");
        return saved !== null ? JSON.parse(saved) : false; // valor inicial false si no existe
    });

    // Cada vez que cambie, lo guardamos en localStorage
    useEffect(() => {
        localStorage.setItem("isCollapsed", JSON.stringify(isCollapsed));
    }, [isCollapsed]);

    // Guardar en localStorage cuando el estado cambie
    useEffect(() => {
        localStorage.setItem('reverseOrder', reverseOrder);
    }, [reverseOrder]);

    //Imagens Hidden and View
    const [hidden, setHidden] = useState(false);

    // Al montar, revisa si existe el valor en localStorage
    useEffect(() => {
        const saved = localStorage.getItem("imagesHidden");
        if (saved !== null) {
            setHidden(saved === "true"); // convierte string → boolean
        }
    }, []);

    // Cada vez que cambia hidden, guarda en localStorage
    useEffect(() => {
        localStorage.setItem("imagesHidden", hidden);
    }, [hidden]);

    const toggleHidden = () => {
        setHidden(!hidden);
    };


    return (
        <>
            {/*New Version POS  */}
            <div class="main-container">
                <header className='py-lg-1'>
                    <div className="row ">
                        <div className='col-xl-3 col-lg-6 col-md-6 col-8 col-sm-6 d-flex justify-content-start align-items-center rounded-pill order-xl-0 order-lg-0 order-md-0 order-sm-0  order-0'>
                            <div className='d-flex gap-1 '>
                                <a href="javascript:location.reload()"
                                    className="d-flex align-items-center flex-fill bd-highlight text-dark text-decoration-none">
                                    <img
                                        className="navbar-logo-post"
                                        src={logo_sp} alt="Logo Smart Pay" />
                                    <span className="text-title-header h5 pt-2  fw-bold align-self-center  position-relative">
                                        Smart Delivery
                                    </span>
                                </a>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 col-12 d-block d-lg-flex justify-content-lg-center d-md-flex justify-content-md-center gap-1 align-items-center flex-column flex-md-row flex-lg-row order-xl-1 order-lg-2 order-md-2   order-sm-2 order-2   overflow-x-auto">
                            <div className='d-flex justify-content-start gap-2 order-lg-3 order-1 mt-lg-0 mt-2'>
                                <div className='tabs-delivery order-2 '>
                                    <div className="border rounded-1">
                                        {/* Tabs */}
                                        <ul
                                            className="nav nav-pills p-3 d-flex flex-nowrap gap-2 overflow-auto text-nowrap nav-tabs-scroll"
                                            role="tablist"
                                        >
                                            <li className="nav-item flex-shrink-0">
                                                <button
                                                    className={`nav-link ${activeTab === 'ALL' ? 'active' : ''}`}
                                                    onClick={() => setActiveTab('ALL')}
                                                >
                                                    Todas <span className="badge bg-secondary ms-1">{counts.ALL}</span>
                                                </button>
                                            </li>
                                            {/**Check that pedidos ya integration is available */}
                                            <RenderIf isTrue={JSON.parse(localStorage.getItem("business")).posIntegrations.find(element => element.pos_integration_id === 5)}>
                                                <li className="nav-item flex-shrink-0">
                                                    <button
                                                        className={`nav-link ${activeTab === 'PEDIDOSYA' ? 'active' : ''}`}
                                                        onClick={() => setActiveTab('PEDIDOSYA')}
                                                    >
                                                        PedidosYa <span className="badge bg-secondary ms-1">{counts.PEDIDOSYA}</span>
                                                    </button>
                                                </li>
                                            </RenderIf>

                                            {/**Check that uber eats integration is available */}
                                            <RenderIf isTrue={JSON.parse(localStorage.getItem("business")).posIntegrations.find(element => element.pos_integration_id === 4)}>
                                                <li className="nav-item flex-shrink-0">
                                                    <button
                                                        className={`nav-link ${activeTab === 'UBER_EATS' ? 'active' : ''}`}
                                                        onClick={() => setActiveTab('UBER_EATS')}
                                                    >
                                                        Uber Eats <span className="badge bg-secondary ms-1">{counts.UBER_EATS}</span>
                                                    </button>
                                                </li>
                                            </RenderIf>



                                            <li className="nav-item flex-shrink-0">
                                                <button
                                                    className={`nav-link ${activeTab === 'ECOMMERCE_DELIVERY' ? 'active' : ''}`}
                                                    onClick={() => setActiveTab('ECOMMERCE_DELIVERY')}
                                                >
                                                    Smartpay Delivery <span className="badge bg-secondary ms-1">{counts.ECOMMERCE_DELIVERY}</span>
                                                </button>
                                            </li>


                                            <li className="nav-item flex-shrink-0">
                                                <button
                                                    className={`nav-link ${activeTab === 'ECOMMERCE_PICKUP' ? 'active' : ''}`}
                                                    onClick={() => setActiveTab('ECOMMERCE_PICKUP')}
                                                >
                                                    Pick&Go <span className="badge bg-secondary ms-1">{counts.ECOMMERCE_PICKUP}</span>
                                                </button>
                                            </li>

                                            <li className="nav-item flex-shrink-0">
                                                <button
                                                    className={`nav-link ${activeTab === 'ECOMMERCE_PENDING_INVOICE' ? 'active' : ''}`}
                                                    onClick={() => setActiveTab('ECOMMERCE_PENDING_INVOICE')}
                                                >
                                                    Pendientes por facturar
                                                    <span className="badge bg-secondary ms-1">
                                                        {counts.ECOMMERCE_PENDING_INVOICE}
                                                    </span>
                                                </button>
                                            </li>

                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>


                        <div className='col-xl-3 col-lg-6  col-md-6 col-sm-6 col-4 d-flex justify-content-end align-items-center gap-1
                order-xl-2 order-lg-1 order-md-1 order-sm-1 order-1  '>
                            <div className='d-flex gap-1  order-1'>
                                <Dropdown className="d-inline" autoClose="outside">
                                    <Dropdown.Toggle id="dropdown-autoclose-outside" className='p-2 bg-secondary bg-opacity-10 rounded-3 text-secondary border-0'>
                                        <i class="uil uil-setting"></i>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Header>   <i class="uil uil-setting"></i> Ajustes de vista</Dropdown.Header>
                                        <Dropdown.Item eventKey="2" className='bg-white'>
                                            <HiddenImg isHidden={hidden} onToggle={toggleHidden} />
                                        </Dropdown.Item>
                                        <Dropdown.Item eventKey="4" className='bg-white'>

                                            <button
                                                onClick={() => setReverseOrder(!reverseOrder)}
                                                className="p-2 bg-secondary bg-opacity-10 rounded-3 text-secondary" title='Cambiar orden de paneles'
                                            >
                                                {reverseOrder
                                                    ? <><i class="uil uil-arrow-right"></i><span>Lado de carrito: Derecho </span></>
                                                    : <> <i class="uil uil-arrow-left"></i><span>Lado de carrito: Izquiero</span></>
                                                }
                                            </button>

                                        </Dropdown.Item>
                                        <Dropdown.Item eventKey="5" className='bg-white' >                   <FullScreen /></Dropdown.Item>
                                        <Dropdown.Item eventKey="6" className='bg-white' >
                                            <button
                                                onClick={() => setIsCollapsed(!isCollapsed)}
                                                className="p-2 bg-secondary bg-opacity-10 rounded-3 text-secondary"
                                            >
                                                {isCollapsed ?

                                                    <>   <i class="uil uil-shopping-cart-alt"></i> <span>Ver Carrito</span></>

                                                    : <>
                                                        <i class="uil uil-angle-left" title='Ocultar panel izquierdo' ></i> <span> Ocultar Carrito </span>
                                                    </>}
                                            </button>



                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>

                                <NavBar ></NavBar>
                            </div>

                        </div>

                    </div>
                </header>

                {/**Totals of delivery */}
                <RenderIf isTrue={machine.allow_see_delivery_totals == 1}>
                    <div class="d-flex   justify-content-lg-center  gap-2 overflow-x-auto">

                        <div class=" my-1 gradient-box ">
                            <div class="stat-card glass-card">
                                <div class="stat-icon"></div>
                                <small class="stat-title d-block">Totales</small>
                                <strong class="stat-value">
                                    ${statsForActiveTab.money.toFixed(2)}
                                </strong>
                            </div>
                        </div>

                        <div class=" my-1 gradient-box ">
                            <div class="stat-card glass-card">
                                <div class="stat-icon"></div>
                                <small class="stat-title d-block">Ordenes totales </small>
                                <strong class="stat-value">↗️ {statsForActiveTab.count}</strong>
                            </div>
                        </div>
                    </div>
                </RenderIf>

                {showAudioUnlock && (
                    <div className="position-fixed bottom-0 start-50 translate-middle-x mb-2 px-3 py-2 rounded-3 bg-warning text-dark shadow"
                        style={{ zIndex: 2000 }}>
                        <button
                            className="btn btn-sm btn-dark me-2"
                            onClick={handleUnlockAudio}
                            title="Habilitar sonido"
                        >
                            🔊 Habilitar sonido
                        </button>
                        <small>Toque “Habilitar sonido” una vez para permitir la alerta audible.</small>
                    </div>
                )}

                {/* Btn float cart */}
                {isCollapsed && (
                    <div className="cart-float" onClick={() => setIsCollapsed(false)}>

                        <div className='d-flex justify-content-center align-items-center
                        '>
                            <i class="fa-solid fa-receipt me-2"></i>
                            <small>Ordenes</small>
                        </div>

                        {/* <span className="cart-count"></span> */}
                    </div>
                )}
                {/* End Btn float cart */}
                <div className={`border content ${reverseOrder ? 'reverse' : ''}`}>
                    {/* Left Panel */}
                    <div class={`left-panel ${isCollapsed ? 'collapsed' : ''}`}>
                        <div className='flex-row d-lg-flex justify-content-lg-between align-items-lg-center gap-2'>
                            <h2 className='m-0'> Transacciones </h2>
                        </div>
                        <Dropdown className="d-inline">
                            <Dropdown.Toggle className="p-2 bg-secondary bg-opacity-10 rounded-3 text-secondary border-0">
                                <i className="fa-regular fa-clock me-2"></i>
                                {timeRange === "TODAY" ? "Hoy" :
                                    timeRange === "7D" ? "Últimos 7 días" :
                                        timeRange === "1M" ? "Último mes" :
                                            timeRange === "3M" ? "Últimos 3 meses" :
                                                timeRange === "1Y" ? "Último año" : "Todo"}
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Header>Filtrar por tiempo</Dropdown.Header>
                                <Dropdown.Item onClick={() => setTimeRange("TODAY")}>Hoy</Dropdown.Item>
                                <Dropdown.Item onClick={() => setTimeRange("7D")}>Últimos 7 días</Dropdown.Item>
                                <Dropdown.Item onClick={() => setTimeRange("1M")}>Último mes</Dropdown.Item>
                                <Dropdown.Item onClick={() => setTimeRange("3M")}>Últimos 3 meses</Dropdown.Item>
                                <Dropdown.Item onClick={() => setTimeRange("1Y")}>Último año</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        {/** Div For ECOMMERCE_PENDING_INVOICE */}
                        <RenderIf isTrue={activeTab === "ECOMMERCE_PENDING_INVOICE"}>
                            <div className="mb-2 p-2 border rounded-3 bg-white shadow-sm">
                                <div className="d-flex flex-wrap justify-content-between align-items-center gap-2">
                                    <div>
                                        <div className="fw-bold text-primary">
                                            Órdenes seleccionadas: {selectedPendingInvoiceOrders.length}
                                        </div>
                                        <small className="text-muted">
                                            Selecciona una o varias órdenes aprobadas sin registrar para consolidarlas y generar una sola factura.
                                        </small>
                                    </div>

                                    <div className="d-flex gap-2">
                                        <button
                                            className="btn btn-outline-primary btn-sm"
                                            type="button"
                                            onClick={selectAllPendingInvoiceOrders}
                                            disabled={ecommercePendingInvoiceOrders.length === 0}
                                        >
                                            Seleccionar todas
                                        </button>

                                        <button
                                            className="btn btn-outline-secondary btn-sm"
                                            type="button"
                                            onClick={clearPendingInvoiceSelection}
                                            disabled={selectedPendingInvoiceOrders.length === 0}
                                        >
                                            Limpiar selección
                                        </button>

                                        <button
                                            className="btn btn-success btn-sm"
                                            type="button"
                                            disabled={selectedPendingInvoiceOrders.length === 0}
                                            onClick={consolidateAndRegisterPendingOrders}
                                        >
                                            {isConsolidatingOrders ? "Procesando..." : "Consolidar y facturar"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </RenderIf>
                        {/** Div for the list of the transactions  */}
                        <div class="left-content bg-light border rounded-3 border-2  ">
                            <div className="list-group mt-2 list-group-checkable">
                                {transactionList(ordersForActiveTab)}
                            </div>
                        </div>

                    </div>
                    {/* Right Panel */}
                    <div className={`right-panel ${isCollapsed ? 'expanded' : ''}`}>
                        <div className='flex-row d-lg-flex justify-content-lg-between align-items-lg-center'>
                            <h2 className='m-0'>Detalles de la orden</h2>
                        </div>
                        <div class="right-content border border-2 pb-5 px-2 pt-2">
                            {orderDetailsTemplate()}
                        </div>
                    </div>
                </div>
            </div>

            {/* End New Version POS  */}
            <div className='kds-main d-none'>
                <main className="container-parent ">
                    <div className="container-pos-left kds-view shadow-sm no-scroll">
                        <div className="flex-container">
                            <div className="item1 mt-5">
                                <div className='d-flex justify-content-center pt-3'>
                                    <h4 className='text-dark fw-bold text-center'>
                                        <i className="uil uil-receipt"></i>
                                        Transacciones
                                    </h4>
                                </div>
                            </div>
                            <div className="item2 py-0 px-1">
                                <div className=" px-1  bd-highlight shopping-wrapper border  border-inset rounded no-scroll bg-light" >
                                    {/* Tabs */}
                                    <ul className="nav nav-tabs mt-2">
                                        <li className="nav-item">
                                            <button
                                                className={`nav-link ${activeTab === 'ALL' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('ALL')}
                                            >
                                                Todas <span className="badge bg-secondary ms-1">{counts.ALL}</span>
                                            </button>
                                        </li>
                                        <li className="nav-item">
                                            <button
                                                className={`nav-link ${activeTab === 'PEDIDOSYA' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('PEDIDOSYA')}
                                            >
                                                PedidosYa <span className="badge bg-secondary ms-1">{counts.PEDIDOSYA}</span>
                                            </button>
                                        </li>
                                        <li className="nav-item">
                                            <button
                                                className={`nav-link ${activeTab === 'UBER_EATS' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('UBER_EATS')}
                                            >
                                                Uber Eats <span className="badge bg-secondary ms-1">{counts.UBER_EATS}</span>
                                            </button>
                                        </li>
                                        <li className="nav-item">
                                            <button
                                                className={`nav-link ${activeTab === 'ECOMMERCE' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('ECOMMERCE')}
                                            >
                                                Ecommerce <span className="badge bg-secondary ms-1">{counts.ECOMMERCE}</span>
                                            </button>
                                        </li>
                                    </ul>
                                    <div className="list-group mt-2 list-group-checkable">
                                        {transactionList(ordersForActiveTab)}
                                    </div>
                                </div>
                            </div>
                            <div className="item3"></div>
                        </div>
                    </div>

                    <div className="container-pos-right no-scroll">
                        <section className='h-100'>
                            <div className="flex-container">
                                <div className="item1 mt-5">
                                    <div className='d-flex justify-content-center'>
                                        <h4 className='text-dark fw-bold'>
                                            <i className="uil uil-notes"></i>
                                            Detalles de la orden
                                        </h4>
                                    </div>
                                </div>
                                <div className="item2 py-0 px-1">
                                    <div className=" px-1  bd-highlight shopping-wrapper border  border-inset rounded no-scroll bg-light" >
                                        <div className="d-flex shadow-sm rounded m-1 bg-white">
                                            <div className="flex-grow-1 m-1">
                                                {orderDetailsTemplate()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="item3 py-0 px-1">
                                    <div></div>
                                </div>
                            </div>
                        </section>
                    </div>

                </main>

            </div >

            {/** Modal to reject order */}
            <Modal show={showRejectModal} onHide={() => setShowRejectModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Motivo del rechazo</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        {rejectionReasons[rejectPlatform]?.map((reason) => (
                            <div className="form-check" key={reason.code}>
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="reason"
                                    value={reason.code}
                                    id={reason.code}
                                    onChange={() => setSelectedReason(reason.code)}
                                />
                                <label className="form-check-label" htmlFor={reason.code}>
                                    {reason.label}
                                </label>
                            </div>
                        ))}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowRejectModal(false)}>
                        Cancelar
                    </Button>
                    <Button
                        variant="danger"
                        disabled={!selectedReason}
                        onClick={() => {
                            stopAlarm(); // stop sound on reject
                            if (rejectPlatform === "PEDIDOSYA") {
                                updatePedidosYaDeliveryOrder({
                                    tokenOrder: orderToReject.token,
                                    status: "order_rejected",
                                    reason: selectedReason,
                                });
                            } else if (rejectPlatform === "UBER_EATS") {
                                updateUberEatsDeliveryOrder(orderDetails.id, branchoffice.id, null, null, null, false, "deny_pos_order", selectedReason, selectedReason)
                            } else if (rejectPlatform === "ECOMMERCE") {
                                updateDeliveryOrder(orderToReject._id, orderDetails, "rejected");
                            }
                            setShowRejectModal(false);
                            setSelectedReason(null);
                            setOrderToReject(null);
                        }}
                    >
                        Confirmar rechazo
                    </Button>
                </Modal.Footer>
            </Modal>
            {/** Modal to link products without mapping */}
            <DeliveryProductMappingModal
                show={showMappingModal}
                onHide={() => {
                    setShowMappingModal(false);
                    setMappingPlatform("");
                }}
                unlinkedProducts={unlinkedProducts}
                unlinkedItems={unlinkedItems}
                unlinkedSegments={unlinkedSegments}
                platform={mappingPlatform || orderDetails.platform}
                orderId={orderDetails.code || orderDetails.display_id}
                setCheckUnlinkedProducts={setCheckUnlinkedProducts}
                setUnlinkedItems={setUnlinkedItems}
                setUnlinkedSegments={setUnlinkedSegments}
                branchofficeId={branchoffice?.id}
                token={token}

            />
            {/** Modal to customize consolidated invoice */}
            <Modal
                show={showConsolidatedInvoiceModal}
                onHide={() => setShowConsolidatedInvoiceModal(false)}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Personalizar factura consolidada</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {/** Step 1: Client information */}
                    {consolidatedInvoiceStep === 1 && (
                        <>
                            <div className="mb-3">
                                <label className="form-label fw-semibold">Nombre en factura</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={consolidatedInvoiceName}
                                    onChange={(e) => setConsolidatedInvoiceName(e.target.value)}
                                    placeholder="Nombre o razón social"
                                />
                            </div>

                            <div className="row">
                                <div className="col-8 mb-3">
                                    <label className="form-label fw-semibold">RUC / Cédula</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={consolidatedInvoiceRuc}
                                        onChange={(e) => setConsolidatedInvoiceRuc(e.target.value)}
                                        placeholder="RUC"
                                    />
                                </div>

                                <div className="col-4 mb-3">
                                    <label className="form-label fw-semibold">DV</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={consolidatedInvoiceDv}
                                        onChange={(e) => setConsolidatedInvoiceDv(e.target.value)}
                                        placeholder="DV"
                                    />
                                </div>
                            </div>

                            <div className="mb-3">
                                <button
                                    className="btn btn-primary btn-sm"
                                    onClick={validDataClientForConsolidated}
                                >
                                    Validar con DGI
                                </button>
                            </div>

                            <div className="mb-3">
                                <label className="form-label fw-semibold">Nombre del evento</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={consolidatedEventName}
                                    onChange={(e) => setConsolidatedEventName(e.target.value)}
                                    placeholder="Nombre del evento"
                                />
                            </div>

                            <small className="text-muted d-block">
                                Aquí defines el nombre del cliente para la factura consolidada y el nombre del evento antes de registrar.
                            </small>
                        </>
                    )}

                    {/** Step 2: Edit product names */}
                    {consolidatedInvoiceStep === 2 && (
                        <>
                            <h6 className="fw-bold mb-3">Editar nombres de productos</h6>

                            {editableConsolidatedProducts.map((product) => (
                                <div className="mb-3" key={product.index}>
                                    <label className="form-label fw-semibold">
                                        Producto #{product.index + 1}
                                    </label>

                                    <input
                                        type="text"
                                        className="form-control"
                                        value={product.name}
                                        onChange={(e) =>
                                            updateEditableConsolidatedProductName(product.index, e.target.value)
                                        }
                                    />

                                    <small className="text-muted">
                                        Original: {product.originalName} | Cantidad: {product.amount} | Precio: ${product.price}
                                    </small>
                                </div>
                            ))}
                        </>
                    )}


                </Modal.Body>

                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => {
                            setShowConsolidatedInvoiceModal(false);
                            setConsolidatedInvoiceStep(1);
                        }}
                    >
                        Cancelar
                    </Button>

                    {consolidatedInvoiceStep === 2 && (
                        <Button
                            variant="outline-secondary"
                            onClick={() => setConsolidatedInvoiceStep(1)}
                            disabled={isConsolidatingOrders}
                        >
                            Atrás
                        </Button>
                    )}

                    {consolidatedInvoiceStep === 1 && (
                        <Button
                            variant="primary"
                            onClick={() => setConsolidatedInvoiceStep(2)}
                        >
                            Siguiente
                        </Button>
                    )}

                    {consolidatedInvoiceStep === 2 && (
                        <Button
                            variant="success"
                            onClick={confirmConsolidatedInvoiceRegistration}
                            disabled={isConsolidatingOrders}
                        >
                            Registrar factura consolidada
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default DeliveryOrders;
